<template>
  <div class="text-center pt-0 onlyThis pa-4" style="     padding:24px 24px !important;;">
    <div class="">
    <v-toolbar :class="(this.tabs === 'c_touchpoints' || this.tabs === 'c_summary') ? 'Toolbarext' : ''" flat
    style="border-radius: 24px; margin-bottom: 12px; padding: 6px;    height: 48px;">
      <template v-slot:extension>
        <v-tabs class="adminHeading" show-arrows slider-color="#10b981 " v-model="tabs">
          <v-tab
            href="#c_details"
            class="app--text"
          >Company details
          </v-tab>
          <v-tab href="#c_summary"
            class="app--text"
          >Company summary
          </v-tab>
          <!-- <v-tab href="#c_finance"
            class="app--text"
          >Finance
          </v-tab> -->
          <v-tab @click="getSatges($route.query.cid)"
            href="#c_touchpoints"
            class="app--text"
          >Touchpoints
          </v-tab>
          <v-tab @click="getAdmins($route.query.cid)"
            href="#c_admins"
            class="app--text"
          >Admins
          </v-tab>
          <v-tab href="#c_log"
            class="app--text"
          >Audit logs
          </v-tab>
          <v-tab @click="getDrivers()" href="#c_drivers"
            class="app--text"
          >Driver framework
          </v-tab>
          <v-tab @click="getAuditLog()" href="#c_activity"
            class="app--text"
          >Activities
          </v-tab>
          <v-tab href="#c_settings"
            class="app--text"
          >Settings
          </v-tab>
          <v-tab href="#c_reports"
            class="app--text"
          >Reports
          </v-tab>
          <v-tab href="#c_vault"
            class="app--text"
          >Vault
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-row class="w-100 ma-0">
      </v-row>
      <v-row class="w-100 ma-0">
        <v-col cols="6" class="pt-0 pr-0">
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_details'">Company details</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_admins'">Admins</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_touchpoints'">Touchpoints</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_log'">Audit log</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_summary'">Company summary</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_drivers'">Drivers</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_activity'">Activity</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_settings'">Settings</h3>
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;" v-if="tabs === 'c_reports'">Reports</h3>
        </v-col>
        <v-col cols="6" class="pa-0 text-right">
          <v-btn small class="mb-2" v-if="tabs === 'c_details' && !editCompanyView && !isLoadingData" style="z-index:99999; color: white;" @click="editDetails(companyData);" color="#10b981 ">
        <v-icon class="mr-2">mdi-square-edit-outline</v-icon> Edit
      </v-btn>
      <v-btn class="mb-2" v-if="tabs === 'c_admins'" style="z-index:99999; color: white;" @click="$refs.addadmin.editView = false;openAdminModal()" color="#10b981 ">
        <v-icon class="mr-2">mdi-plus</v-icon> Add admin
      </v-btn>
      <v-btn  class="mb-2" v-if="tabs === 'c_touchpoints'" style="z-index:99999; color: white;"
       @click="openTouchpointModal()"
        color="#10b981 " 
      >
        <v-icon class="mr-2">mdi-plus</v-icon> Add touchpoint
      </v-btn>
      <v-btn  v-if="tabs === 'c_summary'" class="mb-2" color="#10b981"  style="z-index:99999; color: white;" @click="sendReminder(companyData)">
        <v-icon class="mr-2">mdi-bell-ring-outline</v-icon>Trigger reminders
      </v-btn>
        </v-col>
      </v-row>
  </div>
    <v-tabs-items style=" border-radius: 24px; max-height: 80vh; overflow-y: auto;" v-model="tabs">
      <v-tab-item 
        :value="'c_details'"
      >
        <v-card v-if="companyData && !isLoadingData" flat  style="box-shadow:none; padding:0;background-color: #f8fafc;">
          <v-row v-if="!editCompanyView" class="w-100 ma-0 pt-0">
            <v-col cols="12" class="pa-0">
              <v-card class="hover-elevation bg-white" style="box-shadow:none; border-radius: 24px;">
                <h3 class="mb-0 mt-0 text-left pl-3" style="font-weight: 600;padding-top:10px;">Basic details</h3>
                <v-row class="w-100 ma-0 text-left">
                <v-col cols="3">
                  <img v-if="companyData.company_details && companyData.company_details.company_logo" style="width:60%;" alt="image"  :src="companyData.company_details.company_logo">
                  <img v-else style="width:60%;"  src="../assets/noLogo.png" alt="image">
                </v-col>
                <v-col cols="3" style="font-size: 22px;font-weight: 500;text-transform: uppercase;">
                  {{companyData.company_details.company_name}}
                  <v-chip small color="primary" v-if="companyData.company_details.is_active">
                      Active
                  </v-chip>
                  <v-chip small color="error" v-else>
                      Inactive
                  </v-chip><br>
                  <v-chip small outlined color="primary" v-if="companyData.plan_details.account_type === 'Paid' || companyData.plan_details.account_type === 'paid'">
                      <v-icon style="font-size: 16px;" >
                        mdi-currency-usd
                      </v-icon> Paid
                  </v-chip>
                  <v-chip small outlined color="grey" v-else>
                      <v-icon style="font-size: 16px;">
                        mdi-currency-usd-off
                      </v-icon> Pilot
                  </v-chip>
                  
                </v-col>
                <v-col cols="3" style="">
                  <div style="padding: 0 10px;  gap: 5px;">
                    <p class="mb-0" style="font-size: 0.9rem; color: #555; margin: 0;">Brand Name:</p>
                    <div style="">
                    <span style="font-weight: bold; font-size: 1rem; color: #000;">
                      {{companyData.company_details.brand_name}}
                    </span>
                  </div>
                  </div>
                </v-col>
                <v-col cols="3" style="">
                  <div style="padding: 0 10px;gap: 5px;">
                    <p class="mb-0" style="font-size: 0.9rem; color: #555; margin: 0;">Industry type:</p>
                    <div style="">
                    <span style="font-weight: bold; font-size: 1rem; color: #000;">
                      {{companyData.company_details.company_type}}
                    </span>
                  </div>
                  </div>
                </v-col>
                <v-col cols="6" style="">
                  <div style="padding:0 10px; ">
                    <p class="mb-0" style="font-size: 80%;">Address</p>
                    <div style="">
                    <span style="font-weight:bold;">{{companyData.company_details.company_address}}</span>
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" style="">
                  <div style="   padding:0 10px; ">
                    <p class="mb-0" style="font-size: 80%;">Country</p>
                    <div style="">
                    <span style="font-weight:bold;">{{companyData.company_details.country}}</span>
                    </div>
                  </div>
                </v-col>
                </v-row>
              </v-card>
              <div class="bg-white">
                <v-col cols="12" style="padding:0px;">
                  <v-card class="hover-elevation" style="box-shadow:none;border-radius: 24px;">
                  <p class="mb-0 mt-4 text-left pl-3" style="font-weight: 600;padding-top:10px;font-size:18px;">SPOC details</p>
                  <v-row class="w-100 ma-0 text-left">
                    <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">SPOC name</p>
                      <div style="">
                      <span style="font-weight:bold;">{{companyData.company_details.spoc_name}}</span>
                    </div>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">SPOC email</p>
                      <div style="">
                      <span style="font-weight:bold;">{{companyData.company_details.spoc_email}}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">SPOC phone</p>
                      <div style="">
                      <span style="font-weight:bold;">{{companyData.company_details.spoc_phone}}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                </v-card>
                </v-col>
                <v-col cols="12" style="padding:0px;" v-if="companyData.company_billing_entries.length">
                  <v-card class="hover-elevation" style="box-shadow:none;border-radius: 24px;">
                  <p class="mb-0 mt-4 text-left pl-3" style="font-weight: 600;padding-top:10px;font-size:18px;">Billing details</p>
                  <v-row class="w-100 ma-0 text-left">
                    <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Billing region</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].billing_region">{{companyData.company_billing_entries[0].billing_region}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                    </div>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Allocated user</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].user_booked">{{companyData.company_billing_entries[0].user_booked}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Billing date</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].billing_start_date">{{companyData.company_billing_entries[0].billing_start_date}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Contract start date</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].contract_start_date">{{companyData.company_billing_entries[0].contract_start_date}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Contract renewal date</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].contract_renewal_date">{{companyData.company_billing_entries[0].contract_renewal_date}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Contract valid upto</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].contract_valid_upto">{{companyData.company_billing_entries[0].contract_valid_upto}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Rate per user</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].rate_per_user">{{companyData.company_billing_entries[0].rate_per_user}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Total subscription cost</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].total_subscription_cost">{{companyData.company_billing_entries[0].total_subscription_cost}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">One time setup cost</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].one_time_setup_cost">{{companyData.company_billing_entries[0].one_time_setup_cost}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">HRIS integration cost</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].hris_integration_cost">{{companyData.company_billing_entries[0].hris_integration_cost}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Subsequent invoice amount</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].subsequent_invoice_amount">{{companyData.company_billing_entries[0].subsequent_invoice_amount}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Billing model</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].billing_model">{{companyData.company_billing_entries[0].billing_model}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Payment mode</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].payment_mode">{{companyData.company_billing_entries[0].payment_mode}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Payment frequency</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].payment_frequency">{{companyData.company_billing_entries[0].payment_frequency}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Total annual recurring revenue (ARR)</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].total_arr">{{companyData.company_billing_entries[0].total_arr}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Company invoicing</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].company_invoicing">{{companyData.company_billing_entries[0].company_invoicing}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Company total billing with tax</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].company_total_billing_with_tax">{{companyData.company_billing_entries[0].company_total_billing_with_tax}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Total payment received</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="companyData.company_billing_entries[0].total_payment_received">{{companyData.company_billing_entries[0].total_payment_received}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                </v-card>
                </v-col>
                <v-col cols="12" style="margin-top:20px;padding:0px;">
                  <v-card  class="hover-elevation" style="box-shadow:none;border-radius: 24px;;">
                    <p class="mb-0 mt-4 text-left pl-3" style="font-weight: 600;padding-top:10px;padding-left:10px;font-size:18px;">Avatars</p><br>
                  <v-row class="w-100 ma-0">
                    <v-col cols="12" v-if="companyData && companyData.company_details && companyData.company_details.companies_avatar">
                      <v-row class="w-100 ma-0">
                        <v-col cols="3" v-for="(a, i) in companyData.company_details.companies_avatar" :key="i">
                          <div class="avatarBox" :style="companyData.company_details.company_avatar == i ? `border-color:#10b981 ; border-width: 2px; position:relative;` : ''" >
                            <img style="margin-top:10px; padding: 0px 30%; width:100%;" :src="a" alt="image">
                            <v-icon v-if="companyData.company_details.company_avatar == i" class="mb-0" style="position: absolute; top: 0; right:5px; text-align: center; font-size:40px !important; color:#10b981 ;">mdi-check-all</v-icon>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" style="margin-top:20px;padding:0px;">
                  <v-card  class="hover-elevation" style="box-shadow:none;border-radius: 24px;;">
                    <p class="mb-0 mt-4 text-left pl-3" style="font-weight: 600;padding-top:10px;font-size:18px;">Plans Details :<span style="padding-left:10px;"> {{companyData.plan_details.title}}</span></p>
                    <v-row class="w-100 ma-0 text-left">
                    <v-col cols="4">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Adhoc module</p>
                        <div style="">
                        <span style="font-weight:bold" v-if="companyData.plan_details.adhoc_active">Yes</span>
                      <span style="font-weight:bold" v-else>No</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="companyData.plan_details.adhoc_active">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Adhoc limit</p>
                        <div style="">
                        <span style="font-weight:bold;">{{companyData.plan_details.adhoc_limit}}</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="companyData.plan_details.adhoc_active">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Adhoc remaining limit</p>
                        <div style="">
                        <span style="font-weight:bold;" v-if="companyData.plan_details.adhoc_limit_remaining">{{companyData.plan_details.adhoc_limit_remaining}}</span>
                        <span style="font-weight:bold;" v-else>0</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                    <v-row class="w-100 ma-0 text-left">
                    <v-col cols="4">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Culture module</p>
                        <div style="">
                        <span style="font-weight:bold" v-if="companyData.plan_details.milestone_active">Yes</span>
                      <span style="font-weight:bold" v-else>No</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="companyData.plan_details.adhoc_active">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Touchpoints limit</p>
                        <div style="">
                        <span style="font-weight:bold">{{companyData.plan_details.milestone_limit}}</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="companyData.plan_details.milestone_active">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Touchpoint remaining limit</p>
                        <div style="">
                        <span style="font-weight:bold;" v-if="companyData.plan_details.milestone_limit_remaining">{{companyData.plan_details.milestone_limit_remaining}}</span>
                        <span style="font-weight:bold;" v-else>0</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="w-100 ma-0 text-left">
                    <v-col cols="4">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Exit module</p>
                        <div style="">
                        <span style="font-weight:bold" v-if="companyData.plan_details.exit_active">Yes</span>
                      <span style="font-weight:bold" v-else>No</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Employee wellbeing module</p>
                        <div style="">
                        <span style="font-weight:bold" v-if="companyData.plan_details.employee_wellbeing_active">Yes</span>
                      <span style="font-weight:bold" v-else>No</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div style="padding:0 10px;" class="pt-0">
                        <p class="mb-0" style="font-size: 80%;">Employee recognition module</p>
                        <div style="">
                        <span style="font-weight:bold" v-if="companyData.plan_details.employee_recognition_active">Yes</span>
                      <span style="font-weight:bold" v-else>No</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" v-if="companyData.plan_details.employee_recognition_active && companyData.company_settings.recognition_tags">
                    <div style="padding:0 10px;  min-height:90px;">
                      <p class="mb-0" style="font-size: 80%;">Selected recognition tags</p>
                        <v-chip v-for="(w, i) in companyData.company_settings.recognition_tags" :key="i"
                        color="primary" 
                        class="text-capitalize mr-2 mt-2"
                        outlined
                        >
                        <strong class="text-capitalize">{{ w.replaceAll('_', ' ') }}</strong>
                        </v-chip>
                    </div>
                  </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                  <v-col cols="12" style="margin-top:20px;padding:0px;">
                  <v-card  class="hover-elevation" style="box-shadow:none;border-radius: 24px;;">
                    <p class="mb-0 mt-4 text-left pl-3" style="font-weight: 600;padding-top:10px;font-size:18px;padding-left:20px;">Company Settings</p>
                    <v-col cols="12" class="my-4" style=" border-radius:10px;">
                  <v-row class="w-100 ma-0 text-left">
                    <v-col cols="12">
                      <div style="padding:0;  min-height:90px;">
                        <p class="mb-2" style="font-size: 80%;">Whitelisted email domains</p>
                        <div style="">
                        <div v-if="companyData.company_settings  && companyData.company_settings.whitelisted_email_domains && companyData.company_settings.whitelisted_email_domains.length > 0">
                          <v-chip class="mr-2" v-for="(domain, d) in companyData.company_settings.whitelisted_email_domains" :key="d">
                            {{domain}}
                          </v-chip>
                        </div>
                        <div v-else>
                          No whitelisted email domains found
                        </div>
                      </div>
                      </div>
                    </v-col>
                    <v-col class="py-0  pb-2"
                      :cols="companyData.company_settings.genai_enabled ? '6' : '12'"
                    >
                      <p class="mb-0" style="font-size: 80%;">Amara GenAI</p>
                      <p class="mb-0" style="font-size: 80%;">GenAI</p>
                      <v-radio-group disabled
                        v-model="companyData.company_settings.genai_enabled"
                        row
                      >
                        <v-radio color="#10b981 "
                          label="Enable"
                          :value="true"
                        ></v-radio>
                        <v-radio color="#10b981 "
                          label="Disable"
                          :value="false"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="6" v-if="companyData.company_settings.genai_enabled">
                      <p class="mb-0" style="font-size: 80%;">Select GenAI feature</p>
                      <v-autocomplete
                        disabled
                        :items="GenAIItem"
                        v-model="companyData.company_settings.genai_features"
                        item-text="name"
                        placeholder="Select GenAI feature"
                        outlined dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                    <p class="mb-0" style="font-size: 80%;">Allowed integrations</p>
                    <v-row>
                      <v-col cols="auto" v-for="integration in integrations" :key="integration.value">
                      <v-checkbox
                        disabled
                        placeholder="Allowed integrations"
                        v-model="companyData.company_settings.integration_channels"
                        :label="integration.name"
                        :value="integration.value"
                        dense
                      ></v-checkbox>
                      </v-col>
                    </v-row>
                    </v-col>
                    <v-col  cols="12">
                    <p class="mb-0" style="font-size: 80%;">Allow multipe integrations</p>
                    <v-radio-group disabled
                      v-model="companyData.company_settings.allow_multiple_channels"
                      row
                    >
                      <v-radio color="#10b981 "
                      label="Enable"
                      :value="true"
                      ></v-radio>
                      <v-radio color="#10b981 "
                      label="Disable"
                      :value="false"
                      ></v-radio>
                    </v-radio-group>
                    </v-col>
                    <v-col cols="6">
                      <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Co-branding</p>
                        <v-radio-group disabled
                          v-model="companyData.company_details.chat_cobranding_enabled"
                          row
                        >
                          <v-radio color="#050550"
                            label="Enable"
                            :value="true"
                          ></v-radio>
                          <v-radio color="#050550"
                            label="Disable"
                            :value="false"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Resolution summary</p>
                      <v-radio-group disabled
                      v-model="companyData.company_settings.enable_action_summary"
                      row
                    >
                      <v-radio color="#050550"
                        label="Optional"
                        value="1"
                      ></v-radio>
                      <v-radio color="#050550"
                        label="Mandatory"
                        value="2"
                      ></v-radio>
                      <v-radio color="#050550"
                        label="Disable"
                        value="0"
                      ></v-radio>
                    </v-radio-group>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Touchpoint edit</p>
                  <v-radio-group disabled
                      v-model="companyData.company_details.allow_stage_edit"
                      row
                    >
                      <v-radio color="#050550"
                        label="Enable"
                        :value="true"
                      ></v-radio>
                      <v-radio color="#050550"
                        label="Disable"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                      </div>
                    </v-col>

                    <v-col cols="4">
                      <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Employer Branding</p>
                  <v-radio-group disabled
                      v-model="companyData.company_settings.enable_brand_promotion_feedback"
                      row
                    >
                      <v-radio color="#050550"
                        label="Enable"
                        :value="true"
                      ></v-radio>
                      <v-radio color="#050550"
                        label="Disable"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="companyData.company_settings.enable_brand_promotion_feedback">
                      <div style="padding:10px;  min-height:107px;">
                        <p class="mb-0" style="font-size: 80%;">Select employer branding</p>
                        <v-autocomplete :disabled="!editView"  v-if="companyData.company_settings.enable_brand_promotion_feedback"
                            :items="LinkItem"
                            v-model="companyData.company_settings.brand_promotion_feedback_field"
                            item-text="name" hide-details
                            placeholder="Select employer branding"
                            outlined dense
                          ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Disengaged auto assign</p>
                        
                <v-radio-group disabled
                      v-model="companyData.company_settings.disengaged_auto_assign"
                      row
                    >
                      <v-radio color="#050550"
                        label="Enable"
                        :value="true"
                      ></v-radio>
                      <v-radio color="#050550"
                        label="Disable"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="companyData.company_settings.disengaged_auto_assign">
                      <div style="padding:10px;  min-height:107px;">
                        <p class="mb-0" style="font-size: 80%;">Disengaged auto assignd to</p>
                        <v-autocomplete style="margin-top:6px;" :disabled="!editView"  v-if="companyData.company_settings.disengaged_auto_assign"
                            :items="autoAssignItem" hide-details
                            v-model="companyData.company_settings.disengaged_reference_field"
                            item-text="name"
                            placeholder="Select disengaged auto assignd to"
                            outlined dense
                          ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Fence-sitters auto assign</p>
                        
                <v-radio-group disabled
                      v-model="companyData.company_settings.passively_engaged_auto_assign"
                      row
                    >
                      <v-radio color="#050550"
                        label="Enable"
                        :value="true"
                      ></v-radio>
                      <v-radio color="#050550"
                        label="Disable"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="companyData.company_settings.passively_engaged_auto_assign">
                      <div style="padding:10px;  min-height:107px;">
                        <p class="mb-0" style="font-size: 80%;">Fence-sitters auto assignd to</p>
                        <v-autocomplete style="margin-top:6px;" :disabled="!editView"  v-if="companyData.company_settings.passively_engaged_auto_assign"
                            :items="autoAssignItem" hide-details
                            v-model="companyData.company_settings.passively_reference_field"
                            item-text="name"
                            placeholder="Select fence-sitters auto assignd to"
                            outlined dense
                          ></v-autocomplete>
                      </div>
                    </v-col>
                  <v-col cols="4">
                      <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Auto acknowledge</p>
                        <v-radio-group disabled
                          v-model="companyData.company_settings.auto_acknowledge"
                          row
                        >
                          <v-radio color="#050550"
                            label="Enable"
                            :value="true"
                          ></v-radio>
                          <v-radio color="#050550"
                            label="Disable"
                            :value="false"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </v-col>
                  <v-col cols="4">
                    <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Alert word</p>
                <v-radio-group disabled
                      v-model="companyData.company_settings.chat_alert_word_notification"
                      row
                    >
                      <v-radio color="#050550"
                        label="Enable"
                        :value="true"
                      ></v-radio>
                      <v-radio color="#050550"
                        label="Disable"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                      </div>
                  </v-col>
                  <v-col cols="4">
                    <div style="padding:10px;  min-height:90px;">
                        <p class="mb-0" style="font-size: 80%;">Brand color</p>
                        <v-text-field readonly disabled dense outlined placeholder="Brand color" v-model="companyData.company_settings.chat_color_hex">
                        </v-text-field>
                      </div>
                  </v-col>
                  <v-col cols="12" v-if="companyData.company_settings.chat_alert_word_notification">
                    <div style="padding:10px;  min-height:90px;">
                      <p class="mb-0" style="font-size: 80%;">Selected alert words</p>
                        <v-chip v-for="(w, i) in companyData.company_settings.chat_alert_words" :key="i"
                        color="#050550" 
                        class="text-capitalize mr-2 mt-2"
                        outlined
                        >
                        <strong class="text-capitalize">{{ w }}</strong>
                        </v-chip>
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="companyData.company_settings.inbound_topics">
                    <div style="padding:10px;  min-height:90px;">
                      <p class="mb-0" style="font-size: 80%;">Selected inbound topics</p>
                        <v-chip v-for="(w, i) in companyData.company_settings.inbound_topics" :key="i"
                        color="primary" 
                        class="text-capitalize mr-2 mt-2"
                        outlined
                        >
                        <strong class="text-capitalize">{{ w.replaceAll('_', ' ') }}</strong>
                        </v-chip>
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="companyData.company_settings.language_configured">
                    <div style="padding:10px;  min-height:90px;">
                      <p class="mb-0" style="font-size: 80%;">Language configured</p>
                        <v-chip
                          v-for="(w, i) in companyData.company_settings.language_configured"
                          :key="i"
                          color="primary"
                          class="text-capitalize mr-2 mt-2"
                          outlined
                        >
                          <strong>{{ languageMap[w] || w }}</strong>
                        </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-card class="hover-elevation bg-white" style="box-shadow:none; border-radius: 24px;">
                <h3 class="mb-0 mt-0 text-left pl-3" style="font-weight: 600;padding-top:10px;">Social URLs</h3>
                  <v-row class="w-100 ma-0" style="background: white; border-radius: 24px;">
                <v-col cols="6">
                  
                <v-card outlined class="pa-4 hover-elevation">
                    <v-row>
                          <v-col cols="12">
                            <p class="mb-2" style="font-size: 80%; color: #555;">Facebook URL</p>
                            <hr>
                          </v-col>
                        </v-row>
                        <v-row align="center">
                          <v-col cols="2" class="text-center">
                            <v-icon color="blue" large>mdi-facebook</v-icon>
                          </v-col>
                          <v-divider vertical class="mx-2"></v-divider>
                          <v-col cols="9">
                            <span style="font-weight: bold;" v-if="companyData.company_details.facebook_link">
                              {{ companyData.company_details.facebook_link }}
                            </span>
                            <span v-else>--</span>
                          </v-col>
                        </v-row>
                      </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card outlined class="pa-4 hover-elevation">
                      <v-row>
                        <v-col cols="12">
                          <p class="mb-2" style="font-size: 80%; color: #555;">Glassdoor URL</p>
                          <hr>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="2" class="text-center">
                          <v-icon color="green" large>mdi-domain</v-icon>
                        </v-col>
                        <v-divider vertical class="mx-2"></v-divider>
                        <v-col cols="9">
                          <span style="font-weight: bold;" v-if="companyData.company_details.glassdoor_link">
                            {{ companyData.company_details.glassdoor_link }}
                          </span>
                          <span v-else>--</span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card outlined class="pa-3 hover-elevation">
                      <v-row>
                        <v-col cols="12">
                          <p class="mb-2" style="font-size: 80%; color: #555;">LinkedIn URL</p>
                          <hr>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="2" class="text-center">
                          <v-icon color="blue" large>mdi-linkedin</v-icon>
                        </v-col>
                        <v-divider vertical class="mx-2"></v-divider>
                        <v-col cols="9">
                          <span style="font-weight: bold;" v-if="companyData.company_details.linkedin_link">
                            {{ companyData.company_details.linkedin_link }}
                          </span>
                          <span v-else>--</span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card outlined class="pa-3 hover-elevation">
                      <v-row>
                        <v-col cols="12">
                          <p class="mb-2" style="font-size: 80%; color: #555;">JobStreet URL</p>
                          <hr>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="2" class="text-center">
                          <v-icon color="orange" large>mdi-domain</v-icon>
                        </v-col>
                        <v-divider vertical class="mx-2"></v-divider>
                        <v-col cols="9">
                          <span style="font-weight: bold;" v-if="companyData.company_details.jobStreet_link">
                            {{ companyData.company_details.jobStreet_link }}
                          </span>
                          <span v-else>--</span>
                        </v-col>
                      </v-row>
                    </v-card>
                </v-col>
              </v-row>
              </v-card>
            </v-col>
              </div>
            </v-col>
            </v-row>
        </v-card>
        <v-card v-if="isLoadingData" style="    width: 100%;
    height: 450px;
    padding: 20%;
    text-align: center;
">
<v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
      </v-card>
      </v-tab-item>
      <v-tab-item
        :value="'c_admins'"
      >
        <v-card class="py-4"  style="box-shadow:none;padding: 0 12px 25px;">
          <div v-if="companyAdmins.length < 1" style="border:1px solid #d7d7d7; padding:10%">
            <img style="width:15%;" src="../assets/amara_avatar.png" alt="image"><br>
            <p style="margin-bottom:10px;    color: #9e9e9e !important; font-weight:400;    font-size: 26px;">You haven’t added any admin yet. Please add admin!</p>
            <v-btn class="text-right" style="color: white;"
              depressed @click="$refs.addadmin.editView = false; openAdminModal()"
              color="#10b981 "
            >
              Add admin
            </v-btn>  
          </div>
          <div v-if="companyAdmins.length > 0">
            <v-row class="w-100 ma-0 text-left">
              <v-col cols="1" style="padding-left:25px;">
                S/N
              </v-col>
              <v-col cols="3" class="px-0">
                Name
              </v-col>
              <v-col cols="2">
                Department
              </v-col>
              <v-col cols="2">
                Joining date
              </v-col>
              <v-col cols="1">
                Gender
              </v-col>
              <v-col cols="1">
                Location
              </v-col>
              <v-col cols="2" class="px-0">
                Actions
              </v-col>
            </v-row>
            <v-row class="w-100 ma-0 text-left" v-for="(s, i) in companyAdmins"  :key="i" style="background-color: var(--bg)!important;
              border-radius: 0.375rem!important;
              position: relative;
              border: none!important; border-left: 4px solid #10b981 ;
              box-shadow: 0 4px 16px 11px rgba(0,0,0,.06),0 4px 8px rgba(0,0,0,.1)!important; margin-bottom: 10px !important;">
              <v-col cols="1" style="align-self: center;padding-left:25px;">
                {{i+1}}
              </v-col>
              <v-col cols="3" class="px-0" style="align-self: center;">
                {{s.display_name}}<br>
                {{s.email}}
              </v-col>
              <v-col cols="2" style="align-self: center;">
                {{s.department}}
              </v-col>
              <v-col cols="2" style="align-self: center;">
                {{ moment(s.joining_date).format('DD MMM YYYY') }}
              </v-col>
              <v-col cols="1" style="align-self: center;">
                <span v-if="s.gender">{{s.gender}}</span>
                <span v-else>--</span>
              </v-col>
              <v-col cols="1" style="align-self: center;" @click="getSatgeDetails(s.stage_details.survey, s.stage_details.id)">
                {{s.location}}
              </v-col>
              <v-col cols="2" class="px-0" style="align-self: center;">
                <v-btn icon  @click="openAdminModal(s)">
                  <v-icon>mdi-lead-pencil</v-icon>
                </v-btn>
                <v-btn class="button" v-if="s.user_id" text @click="resendEmail(s.user_id)">
                  Resend email
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :value="'c_touchpoints'"
      >
        <v-card style="box-shadow:none;padding: 0 12px 25px;">
          <div v-if="companyTouchpoints.length < 1" style="border:1px solid #d7d7d7; padding:10%">
            <img style="width:15%;" src="../assets/amara_avatar.png" alt="image"><br>
            <p style="margin-bottom:10px;    color: #9e9e9e !important; font-weight:400;    font-size: 26px;">You haven’t added any touchpoint yet. Please add touchpoint!</p>
            <v-btn class="text-right" style="color: white;"
              depressed :loading="loading" @click="openTouchpointModal()"
              color="#10b981 " 
            >
              Add touchpoint
            </v-btn>  
          </div>
          <div v-if="companyTouchpoints.length > 0">
            <v-row class="mt-3 mb-3">
                <v-col cols="6" class="text-left pl-5 d-flex align-center">
                <div>
                  <v-btn
                  class="button"
                  @click="bulkActionTouchpoint = [];bulkChatUser = '';selectAll = false;reportDialog = true;getstagesBulk($route.query.cid);"
                  >
                  <v-icon class="mr-2">mdi mdi-pencil-box-multiple-outline</v-icon>
                  Bulk action
                  </v-btn>
                  <v-btn
                  class="button ml-4"
                  @click=";bulkActionEmails = [];bulkEmailDialog = true;emailpage = 1; getstagesBulk($route.query.cid);selectedTemplate = null;"
                  >
                  <v-icon class="mr-2">mdi mdi-pencil-box-multiple-outline</v-icon>
                  Bulk Email Template
                  </v-btn>
                </div>
                </v-col>
                <v-col cols="6" class="text-right pr-5 d-flex align-center justify-end">
                <v-btn class="button"
                  depressed @click="openSortingModal()"
                >
                  <v-icon class="mr-2">mdi-sort</v-icon>
                  Sort list
                </v-btn>
                </v-col>
            </v-row>
            <v-row class="w-100 ma-0 text-left">
              <v-col cols="1">
                S/N
              </v-col>
              <v-col cols="2">
                Touchpoint
              </v-col>
              <v-col cols="2">
                Trigger time
              </v-col>
              <v-col cols="3">
                Chat for user
              </v-col>
              <v-col cols="1">
                Status
              </v-col>
              <v-col cols="3">
                Action
              </v-col>
            </v-row>
            <v-row class="w-100 ma-0 text-left hover-elevation" v-for="(s, i) in companyTouchpoints"  :key="i" style="border:1px solid lightgray; margin-top:8px !important;margin-bottom:10px !important;border-radius:6px;text-align:center;">
              <v-col cols="1" class="d-flex align-center">
                {{((pagination.page-1)*20)+i+1}}
              </v-col>
              <v-col cols="2" v-if="s.stage_details" class="d-flex align-center"> 
                {{s.stage_details.title}}
              </v-col>
              <v-col cols="2" v-if="s.stage_details" class="d-flex align-center">
                {{s.stage_details.trigger_time_ym_formatted}}
              </v-col>
              <v-col cols="3" v-if="s.stage_details" class="d-flex align-center">
                <span v-if="s.stage_details.chatFromUser__name">{{s.stage_details.chatFromUser__name}}</span>
                <span v-else>--</span>
              </v-col>
              <v-col cols="1" v-if="s.stage_details" class="d-flex align-center">
                <v-chip class="text-capitalize">{{s.stage_details.status}}</v-chip>
              </v-col>
              <v-col cols="3" v-if="s.stage_details" style="align-self:center" >
                <v-btn class="button" small v-if="s.stage_details.status === 'live'" outlined @click="deactivateStage(s.stage_details.id)" style="width:120px" color="#10b981 ">
                  Deactivate
                </v-btn>
                <v-btn class="button"  v-if="s.stage_details.status === 'draft'" small @click="getSatgeDetails(s.stage_details.survey, s.stage_details.id, s.stage_details)" style="width:120px" color="#10b981 ">
                  Activate
                </v-btn>
                <v-menu offset-y >
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-4" v-bind="attrs" v-on="on" icon small>
                    <v-icon>
                    fa-solid fa-ellipsis-v
                    </v-icon>
                  </v-btn>
                  </template>
                  <v-list>
                  <v-list-item @click="getSatgeDetails(s.stage_details.survey, s.stage_details.id, s.stage_details)">
                    <v-list-item-icon>
                    <v-icon>
                      fa-regular fa-pen-to-square
                    </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Edit Touchpoint</v-list-item-title>
                  </v-list-item>
                  <v-list-item 
                    v-if="s.stage_details && s.stage_details.status === 'draft'" 
                    @click="deleteStage(s.stage_details.id)">
                    <v-list-item-icon>
                    <v-icon>
                      fa-regular fa-trash-can
                    </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item >
                  <v-list-item @click="editemail(s.stage_details)">
                    <v-list-item-icon>
                    <v-icon>
                      fa-regular fa-file-lines
                    </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Edit Template</v-list-item-title>
                  </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </div>
          <div class="d-flex" v-if="companyTouchpoints.length > 0">
        <v-flex xs1></v-flex>
        <v-flex class="pr-4 mb-0 ml-3" xs10 style="text-align:center">
          <v-pagination
            class="adhoc--text"
            color="#10b981 "
            v-model="pagination.page"
            :length="pagination.length"
            :total-visible="7"
            @input="getSatges($route.query.cid)"
            circle
          ></v-pagination>
        </v-flex>
        <v-flex xs1></v-flex>
      </div>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :value="'c_summary'"
      >
        <company-summary ref="companysummary" />
      </v-tab-item>
      <v-tab-item
        :value="'c_log'"
      >
      <company-log ref="companylog" />
      </v-tab-item>
      <v-tab-item v-if="companyData"
        :value="'c_drivers'"
      >
        <v-card flat  style="box-shadow:none; padding: 0 12px 25px; background: #f8fafc;">
          <v-row class="w-100 ma-0">
            <v-col cols="12" class="text-left" v-for="(driver, i) in driverList" :key="i">
              <v-card style="height:100%; border-radius: 24px;; box-shadow: none; position: relative; padding-bottom: 60px;"
                class="mx-auto px-4 pt-4"
              >
              <v-row class="w-100 ma-0" style="align-items: center;">
                <v-col cols="6" class="pa-0">
                  <h3>{{i.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</h3>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-btn @click="addNewSubDriver(i)"  color="button">Add new subdriver</v-btn>
                </v-col>
              </v-row>
                
              <div>
                <v-list-item class="" style="border:1px solid lightgray;border-radius:24px;margin-top:2px;margin-bottom:12px;cursor: default; min-height:30px;     width: 32.33%;  display: inline-block;margin-right: 1%;" v-for="(subdri, j) in driver" :key="j">
                  <v-list-item-content class="">
                    <v-list-item-title><span style="">{{subdri.sub_driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
                      <span style="float:right; cursor: pointer; padding: 0 5px;" @click.stop="deleteSubDriver(subdri)">
                        <v-icon style="color:#10b981; font-size: 16px; ">mdi-delete-outline</v-icon>
                      </span> 
                      <span style="float:right; cursor: pointer; padding: 0 5px" @click="editSubDriver(i, subdri)">
                        <v-icon  style="color:#10b981; font-size: 16px; ">mdi-pencil</v-icon>
                      </span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :value="'c_activity'"
      >
        <v-card flat  style="box-shadow:none; min-height: 460px; max-height: 550px; overflow-y: auto; overflow-x: hidden; padding: 0 24px;">
          <div style=" background: white; border-radius:10px; padding: 0px 0px;text-align:left;margin-top:10px;" >
          <v-row class="ma-0 w-100">
            <v-col cols="3">
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <div style="float:right" class="right d-flex align-center" >
                <div class="pre-icon cursor-pointer mr-3 pt-1" @click="displayPre()">
                  <v-icon>mdi-arrow-left-drop-circle-outline</v-icon>
                </div>
                <div>{{getPreNumber}} - {{getNextNumber}} of {{totalCount}}</div>
                <div class="next-icon cursor-pointer ml-3 pt-1" @click="displayNext()">
                  <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div style="" class="infinite-wrapper">
                <v-timeline style="padding:20px 0px 0 0;"
                  align-top
                  dense
                >
                  <v-timeline-item
                    v-for="(audit, i) in auditLog"
                    :key="i"
                    :color="getColor(audit.type)"
                    :icon="getIcon(audit.type)"
                    fill-dot
                  >
                    <v-card
                      :color="getColor(audit.type)"
                      dark
                    >
                      <v-card-title style="font-size: 14px;padding: 0 10px; color: #263238;">
                        <v-row>
                          <v-col cols="10">
                            {{audit.type[0].toUpperCase() + audit.type.slice(1).split('_').join(' ')}}
                          </v-col>
                          <v-col cols="2">
                            <p class="mb-0"
                            v-if="audit.type !== 'user_login_failed' && audit.type !== 'user_logged_in' && audit.type !== 'user_logged_out' "
                            @click="viewLogDetails(audit)" style="font-size: 80%;text-decoration: underline;text-align: right;cursor:pointer;">View details</p>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-card-text class="white pa-2 text-left text--primary">
                        <v-row>
                          <v-col cols="4">
                            {{ moment(audit.created_at).format('DD MMM YYYY hh:mm  a') }}
                          </v-col>
                          <v-col cols="8">
                            <p v-if="audit.type === 'user_logged_in'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has logged in successfully.</p>
                            <p v-if="audit.type === 'user_logged_out'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has logged out successfully.</p>
                            <p v-if="audit.type === 'report_download'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has downloaded the <strong><span v-if="audit.data && audit.data.report_name">{{audit.data.report_name}}</span></strong>.</p>
                            <p v-if="audit.type === 'admin_added'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has added admin.</p>
                            <p v-if="audit.type === 'plan_settings'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has changed plan details.</p>
                            <p v-if="audit.type === 'driver_updated'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has updated sub driver <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'driver_added'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has added a new sub driver <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'driver_deleted'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has deleted a sub driver <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'company_settings'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has changed company settings.</p>
                            <p v-if="audit.type === 'company_profile'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has changed company profile.</p>
                            <p v-if="audit.type === 'touchpoint_upload'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has uploaded the touchpoint.</p>
                            <p v-if="audit.type === 'touchpoint_deleted'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has deleted a touchpoint <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'touchpoint_updated'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has updated a touchpoint <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'template_updated'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has updated a template <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'company_added'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has added this company.</p>
                            <p v-if="audit.type === 'reminders_trigger'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span>  has trigger reminders.</p>
                            <p v-if="audit.type === 'touchpoint_index'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has change touchpoint index this company.</p>
                            <p v-if="audit.type === 'sub_driver_updated'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has updated sub driver <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'sub_driver_added'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has added a new sub driver <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                            <p v-if="audit.type === 'sub_driver_deleted'" class="mb-0"><span v-if="audit.created_by && audit.created_by.display_name">{{audit.created_by.display_name}}</span> has deleted a sub driver <strong v-if="audit && audit.data">{{audit.data}}</strong>.</p>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
                <infinite-loading @infinite="infiniteHandler" spinner="waveDots" force-use-infinite-wrapper=".infinite-wrapper">
                  <span slot='no-more'>{{' '}}</span>
                  <span slot='no-results'>{{' '}}</span>
                </infinite-loading>
              </div>
            </v-col>
          </v-row>
        </div>
        </v-card>
      </v-tab-item>
      <v-tab-item style="background: #f8fafc;"
        :value="'c_settings'"
      >
      <v-toolbar flat
                style="border-radius: 24px; margin-bottom: 12px; padding: 6px;    height: 48px;    background: #f3f3ff;
    max-width: fit-content;">
                  <template v-slot:extension>
                    <v-tabs class="adminHeading" show-arrows slider-color="#10b981 " v-model="tabsettings">
                      <v-tab
                        href="#c_email_template"
                        class="app--text"
                      >Email template
                      </v-tab>
                      <v-tab href="#c_chat_statements"
                        class="app--text"
                      >Continuous chat statement
                      </v-tab>
                      <v-tab href="#c_inbound_statements"
                        class="app--text"
                      >Inbound chat statements
                      </v-tab>
                    </v-tabs>
                  </template>
                </v-toolbar>
        <div v-if="tabsettings === 'c_email_template'" style="    background: white; border-radius:24px; padding: 24px;text-align:left;margin-bottom:24px;">
          <h3 class="my-2 mt-4 text-left">Email template</h3>
          <email-template ref="emailTemplate" class="" style="background-color: white;"/>
        </div>
        <div v-if="tabsettings === 'c_chat_statements'" style="    background: white; border-radius:24px; padding: 24px;text-align:left;margin-bottom:24px;">
          <h3 class="my-2 mt-4 text-left">Chat statements</h3>
          <welcomeintend ref="welcomeintend" class="" style="background-color: white;"/>
        </div>
        <div v-if="tabsettings === 'c_inbound_statements'" style="    background: white; border-radius:24px; padding: 24px;text-align:left;margin-bottom:24px;">
          <h3 class="my-2 mt-4 text-left">Inbound statements</h3>
          <inboundstatements ref="inboundstatements" class="" style="background-color: white;"/>
        </div>
      </v-tab-item>
      <v-tab-item style="background: #f8fafc;"
        :value="'c_reports'"
      >
      <div style="    background: white; border-radius:24px; padding: 24px;text-align:left;margin-bottom:24px;">
          <div style="padding: 0px 0px;text-align:left;min-height:500px;" >
            <v-row class="w-100 ma-0">
              <v-col class="pa-0" cols="4">
                <div style="border-radius: 24px; margin: 12px; background:#fff;border:1px solid lightgray; box-shadow: none !important;" class="am-card-animation pa-6 text-center">
                  <p class="am-table-title mb-2" style="font-weight: 500; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" title="Happiness Index Report">Happiness Index Report</p>
                  <p style="min-height: 96px;" class="am-table-sub-title">This report consolidates the feedback ratings from employees who have completed chat interactions. It includes options to download all chats or the latest completed chats feedback details.</p>
                  <v-btn text elevation="0" class="am-table-title button" @click="dialogOpen = true"><v-icon class="mr-2" style="font-size: 14px;">fa-regular fa-file-download</v-icon><span class="am-table-title" style="font-size: 12px !important;">Download</span> </v-btn>
                </div>
              </v-col>
              <v-col class="pa-0" cols="4">
                <div style="border-radius: 24px; margin: 12px; background:#fff;border:1px solid lightgray;     box-shadow: none !important;" class="am-card-animation pa-6 text-center">
                  <p class="am-table-title mb-2" style="font-weight: 500; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" title="Employee Policy Acknowledgement Report">Employee Policy Acknowledgement Report</p>
                  <p style="min-height: 96px;" class="am-table-sub-title">This report provides a detailed list of employees who have acknowledged and accepted our company's policies.</p>
                  <v-btn class="am-table-title button" text elevation="0" @click="downloadRatingReports()"><v-icon class="mr-2" style="font-size: 14px;">fa-regular fa-file-download</v-icon><span class="am-table-title" style="font-size: 12px !important;">Download</span> </v-btn>
                </div>
              </v-col>
              <v-col class="pa-0" cols="4">
                <div style="border-radius: 24px; margin: 12px; background:#fff;border:1px solid lightgray;     box-shadow: none !important;" class="am-card-animation pa-6 text-center">
                  <p class="am-table-title mb-2" style="font-weight: 500; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" title="Dashboard Login Logs">Dashboard Login Logs</p>
                  <p style="min-height: 96px;" class="am-table-sub-title">This report provides a comprehensive overview of all dashboard admin login activities, including timestamps, IP addresses, and user identification. It is designed to facilitate security audits and track access patterns.</p>
                  <v-btn class="am-table-title button" text elevation="0" @click="downloadLoginReports()"><v-icon class="mr-2" style="font-size: 14px;">fa-regular fa-file-download</v-icon><span class="am-table-title" style="font-size: 12px !important;">Download</span> </v-btn>
                </div>
              </v-col>
              
              <v-col class="pa-0" cols="4">
                <div style="border-radius: 24px; margin: 12px; background:#fff;border:1px solid lightgray;     box-shadow: none !important;" class="am-card-animation pa-6 text-center">
                  <p class="am-table-title mb-2" style="font-weight: 500; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" title="Dashboard Login Logs">Export Touchpoints</p>
                  <p class="am-table-sub-title">This report provides a detailed mapping of Touchpoints including questions, postbacks, and rating metrics.</p>
                  <v-btn class="am-table-title button" text elevation="0" @click="langDialog = true"><v-icon class="mr-2" style="font-size: 14px;">fa-regular fa-file-download</v-icon><span class="am-table-title" style="font-size: 12px !important;">Download</span> </v-btn>
                </div>
              </v-col>
            </v-row>
        </div>
          </div>
      </v-tab-item>
      <v-tab-item style="background: #f8fafc;"
        :value="'c_vault'"
      >
        <div style="">
          <company-vault ref="companyVault" />
        </div>
      </v-tab-item>
    </v-tabs-items>
    <addTouchpoint ref="addtouchpoint" class="" />
    <stageDetails ref="stagedetails" class="" />
    <addAdmin ref="addadmin" class="" />
    <v-dialog
      v-model="dialogOpen"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5" style="border-bottom: 1px solid lightgray;margin-bottom: 20px;">
          Happiness index report
        </v-card-title>
        <v-card-text style="min-height: 130px;">
          <v-row>
            <v-col cols="6">
              <div class="reportOption am-table-title" :class="reportTypeFeedback === 'culture_dashboard' ? 'active' : ''" @click="reportTypeFeedback = 'culture_dashboard'; reportType = 'all'">
                Continuous chat feedback
              </div>
            </v-col>
            <v-col cols="6">
              <div class="reportOption am-table-title" :class="reportTypeFeedback === 'adhoc_dashboard' ? 'active' : ''" @click="reportTypeFeedback = 'adhoc_dashboard'">
                Ad-hoc chat feedback
              </div>
            </v-col>
          </v-row>
          <v-row v-if="reportTypeFeedback === 'culture_dashboard'" class="mt-0">
            <v-col cols="6" class="text-center pt-0" v-for="(t, ti) in reportItem" :key="ti" style="max-width: fit-content;">
              <v-radio-group v-model="reportType" hide-details>
                <v-radio
                  color="primary" style="overflow: revert;"
                  class="am-table-title"
                  :label="t.label"
                  :value="t.value"
                  hide-details
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <div class="mt-2">
            <v-divider></v-divider>
            <div class="mt-2"></div>
            <span class="filter-title am-table-title pt-2"> Chat completion date</span>
            <v-radio-group @change="updateChatCompleteDate" v-model="chatCompleteDateModel">
                  <v-radio
                    color="primary"
                    v-for="(t, ti) in chatCompletion.presets"
                    :key="ti"
                    :value="t.range1"
                  >
                  <template v-slot:label>
                    <v-tooltip style="z-index:999;" bottom>
                      <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs"
                          v-on="on">{{ t.label }}</span>
                      </template>
                      <span style="z-index:999;">{{ `Start date: ${(t.range[0])} | End date: ${(t.range[1])}` }}</span>
                    </v-tooltip>
                  </template>
                </v-radio>
                  <v-dialog
                    ref="completionMenu"
                    v-model="completionMenu"
                    :return-value.sync="completionDates"
                    persistent
                    width="max-content"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        class="daterangeOverview"
                        color="primary"
                        value="custom date"
                        v-bind="attrs"
                        v-on="on"
                      >
                      <template v-slot:label>
                        <v-tooltip v-if="completionDates.length === 2" style="z-index:999;" bottom>
                          <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs"
                              v-on="on">Select Range</span>
                          </template>
                          <span style="z-index:999;">{{ `Start date: ${(completionDates[0])} | End date: ${(completionDates[1])}` }}</span>
                        </v-tooltip>
                        <span v-else>Select Range</span>
                      </template>
                    </v-radio>
                    </template>
                    <v-date-picker
                      range
                      scrollable
                      v-model="completionDates"
                      color="primary"
                      :min="chatCompletion.minDate"
                      :max="chatCompletion.maxDate"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="completionMenu = false;clearModeldateComp()">Cancel</v-btn>
                      <v-btn :disabled="completionDates.length !== 2" text color="primary" @click="$refs.completionMenu.save(completionDates);updateChatCompleteDate(completionDates)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-radio-group>
                <p class="ml-3 cursor-pointer" v-if="chatCompleteDateModel" @click="resetComDate()">Remove selection</p>
          </div>
        </v-card-text>
        <v-card-actions style="border-top: 1px solid lightgray;">
          <v-btn class="am-table-title mx-1" text @click="reportType = 'all';dialogOpen = false;">Cancel</v-btn>
          <v-spacer></v-spacer>
            <v-btn :loading="reportloading" :disabled="!reportType" class="am-table-title mx-1" style="color:white" color="primary" @click="downloadRating(reportType)">Download</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="langDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Touchpoint language
        </v-card-title>
        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" class="text-center pt-0">
              <v-radio-group v-model="languageConfigured">
                <v-radio
                  color="primary"
                  v-for="(t, ti) in languageItem"
                  :key="ti"
                  :label="t.text"
                  :value="t.value"
                ></v-radio>
                </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn class="am-table-title mx-1" text @click="languageConfigured = 'en';langDialog = false;">Cancel</v-btn>
          <v-spacer></v-spacer>
            <v-btn :loading="reportloading" :disabled="!languageConfigured" class="am-table-title mx-1" style="color:white" color="primary" @click="downloadTouchpointReports()">Download</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="subdriverDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          <span v-if="selectedSubDriver">Update</span>
          <span v-else>Add</span>
        </v-card-title>

        <v-card-text>
          <p v-if="selectedSubDriver">Update <strong style="text-transform:lowercase">{{selectedSubDriver.sub_driver}}</strong> in <strong><span style="text-transform:lowercase">{{selectedDriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span></strong></p>
          <p v-else>Add new sub driver in <strong><span style="text-transform:lowercase">&nbsp;{{selectedDriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span></strong></p>
          <label>Sub driver name</label>
          <v-text-field dense outlined placeholder="Please enter sub driver name" v-model="subdriverName">
          </v-text-field>
          <label>Description</label>
          <v-textarea dense outlined placeholder="Please enter description" v-model="subDriverDescription">
          </v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color=""
            text
            @click="closeDialog()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="selectedSubDriver"
          class="button"
          @click="updateSubdriver()"
          >
            Update
          </v-btn>
          <v-btn v-else
            class="button"
            @click="saveSubdriver()"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="logDetails"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          Audit details
        </v-card-title>
        <v-card-text style="max-height: 500px; overflow-y:auto;">
          <v-row v-if="logData">
              <v-col cols="3">
                <strong>Date : </strong>
              </v-col>
              <v-col cols="9">
                <p class="mb-0">{{moment(logData.created_at).format('DD-MM-YYYY  HH:mm')}}</p>
              </v-col>
              <v-col cols="3">
                <strong>IP Address : </strong>
              </v-col>
              <v-col cols="9">
                <p class="mb-0" v-if="logData.extra_data">{{logData.extra_data.client_ip}}</p>
              </v-col>
              <v-col cols="3">
                <strong>User : </strong>
              </v-col>
              <v-col cols="9">
                <strong v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</strong>
                <strong v-else>--</strong><br>
                <p class="mb-0" v-if="logData.created_by && logData.created_by.email">{{logData.created_by.email}}</p>
                <p class="mb-0" v-else>--</p>
              </v-col>
              <v-col cols="3">
                <strong>Activity : </strong>
              </v-col>
              <v-col cols="9">
                <p v-if="logData.type === 'user_logged_in'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has logged in successfully.</p>
                <p v-if="logData.type === 'user_logged_out'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has logged out successfully.</p>
                <p class="mb-0" v-if="logData && logData.type">{{logData.type.split('_').join(' ')}}</p>
                <p v-if="logData.type === 'report_download'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has downloaded the <strong><span v-if="logData && logData.data && logData.data.report_name">{{logData.data.report_name}}</span></strong>.</p>
                <p v-if="logData.type === 'admin_added'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has added admin.</p>
                <p v-if="logData.type === 'plan_settings'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has changed plan details.</p>
                <p v-if="logData.type === 'driver_updated'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has updated sub driver <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
                <p v-if="logData.type === 'driver_added'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has added a new sub driver <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
                <p v-if="logData.type === 'driver_deleted'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has deleted a sub driver <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
                <p v-if="logData.type === 'company_settings'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has changed company settings.</p>
                <p v-if="logData.type === 'company_profile'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has changed company profile.</p>
                <p v-if="logData.type === 'touchpoint_upload'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has uploaded the touchpoint.</p>
                <p v-if="logData.type === 'touchpoint_deleted'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has deleted a touchpoint <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
                <p v-if="logData.type === 'touchpoint_updated'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has updated a touchpoint <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
                <p v-if="logData.type === 'company_added'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has added this company.</p>
                <p v-if="logData.type === 'reminders_trigger'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has trigger reminders.</p>
                <p v-if="logData.type === 'reminders_trigger'" class="mb-0">
                  <span v-if="logData.data && logData.data.inProgress">Inprgress: {{logData.data.inProgress}}</span>
                  <span v-else>Inprgress: 0</span>
                  <br>
                  <span v-if="logData.data && logData.data.initiated">Initiated: {{logData.data.initiated}}</span>
                  <span v-else>Initiated: 0</span>
                </p>
                <p v-if="logData.type === 'sub_driver_updated'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has updated sub driver <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
                <p v-if="logData.type === 'sub_driver_added'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has added a new sub driver <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
                <p v-if="logData.type === 'sub_driver_deleted'" class="mb-0"><span v-if="logData.created_by && logData.created_by.display_name">{{logData.created_by.display_name}}</span> has deleted a sub driver <strong v-if="logData && logData.data">{{logData.data}}</strong>.</p>
              </v-col>
              <v-col v-if="logData.type === 'touchpoint_upload' && logData.data" cols="3">
                <strong>Results :  </strong>
              </v-col>
              <v-col v-if="logData.type === 'touchpoint_upload' && logData.data" cols="9">
                Success : {{logData.data.success}}<br>
                Failure : {{logData.data.failure}} <br>
                Download file : <a @click="downloadTouchpointSheet(logData.data.file_url)">Download</a>
              </v-col>
              <v-col cols="3" v-if="logData.old_data">
                <strong>Old data : </strong>
              </v-col>
              <v-col cols="9" v-if="logData.old_data">
                <span v-for="(old, i) in logData.old_data" :key="i">
                  <span v-if="i !== 'activatedAt' && i !== 'company_avatar_id'" >
                    <span style="">
                      {{i.split('_').join(' ')}}
                    </span>: {{old}} <br>
                  </span>
                  <span v-if="i === 'activatedAt'"> Go live date : {{moment(old).format('DD-MM-YYYY  HH:mm')}}</span><br v-if="i === 'activatedAt'">
                  <span v-else-if="i === 'company_avatar_id'">
                    Old company avatar : <br>
                    <img style="width:13%;" :src="getAvatarAudit(old)" alt="image"><br>
                  </span>
                </span>
              </v-col>
              <v-col cols="3" v-if="logData.new_data">
                <strong>New data : </strong>
              </v-col>
              <v-col cols="9" v-if="logData.new_data">
                <span v-for="(newData, j) in logData.new_data" :key="j">
                  <span v-if="j !== 'activatedAt' && j !== 'company_avatar_id'">
                    {{j.split('_').join(' ')}}: {{newData}} <br>
                  </span>
                  <span v-else-if="j === 'activatedAt'"> Go live date : {{moment(newData).format('DD-MM-YYYY  HH:mm')}}</span><br v-if="j === 'activatedAt'">
                  <span v-else-if="j === 'company_avatar_id'">
                    New company avatar : <br>
                    <img style="width:13%;" :src="getAvatarAudit(newData)" alt="image"><br>
                  </span>
                </span>
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
            @click="logDetails = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSorting"
      persistent
      max-width="800"
    >
      <v-card>
        <v-card-title class="text-h5">
          <v-row>
            <v-col cols="7">Touchpoint list</v-col>
            <v-col cols="5" class="text-right">
              <v-select
                v-model="sortBy"
                @change="sortByNew()"
                style="max-width:280px;"
                :items="items"
                item-text="name"
                placeholder="Sort by"
                label="Sort by"
                outlined
                dense
                attach
                hide-details=""
                clearable
              ></v-select>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px; overflow-y: auto;" v-if="loaderforAction">
          <amara-loader></amara-loader>
        </v-card-text>
        <v-card-text style="max-height: 400px; overflow-y: auto;" v-if="touchpointList && !loaderforAction">
          <draggable
            :list="touchpointList.data"
            class="list-group py-4"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
            :animation="100"
          >
            <div
              v-for="(item, i) in touchpointList.data"
              style="width:33.33%; display: inline-block;"
              :key="i"
            >
              <v-row class="w-100 ma-2" style="border:1px solid #cecece; cursor:pointer; border-radius:6px;padding:10px;">
                <v-col cols="2" class="ma-0 pa-0" style="">{{i+1}}.</v-col>
                <v-col class="ma-0 pa-0" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" :title="item.stage_details.title">{{ item.stage_details.title}}</v-col>
                <v-col class="ma-0 pa-0" cols="1">
                  <v-icon style="font-size:16px; float:right;" class="">mdi-arrow-all</v-icon>
                </v-col>
              </v-row> 
            </div>
          </draggable>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
          style="border:1px solid lightgray"
            text
            @click="dialogSorting = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="button"
            @click="saveSortList()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="800px"
      v-model="reportDialog" persistent
      scrollable
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          Bulk action
        </v-card-title>
        <v-card-subtitle>
          Please select touchpoints on which you want to take bulk action.
        </v-card-subtitle>
        <v-card-text style="height: 500px; overflow-y: auto;" v-if="loaderforActionBulk">
          <amara-loader></amara-loader>
        </v-card-text>
        <v-card-text style="height: 500px;" v-if="!loaderforActionBulk">
          <v-row style="height: 80px; overflow-y:auto;">
            <v-col cols="6" class="text-left" style="align-self: center">
              <v-checkbox
              v-model="selectAll"
              label="Select all"
              style="width: 50px;margin:0px !important"
              hide-details
              @change="selectAll === true ? bulkActionTouchpoint = companyTouchpointsBulk : bulkActionTouchpoint = []"
            ></v-checkbox>
            </v-col>
        </v-row>
          <v-row no-gutters class="px-3"  style="height: 420px; overflow-y:auto;" v-if="companyTouchpointsBulk.length > 0">
            <v-col cols="4"
              v-for="(col, index) in companyTouchpointsBulk"
              :key="index"
            >
              <v-checkbox
                :id="index.toString()"
                hide-details
                v-model="bulkActionTouchpoint"
                :label="col.stage_details.title"
                :value="col"
              ></v-checkbox>
            </v-col>
          </v-row>
          <div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn class="button" @click="reportDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="button" :disabled="bulkActionTouchpoint.length === 0" :loading="deleteStageL" color="#10b981 " @click="deleteStage(null, 'bulk')">Bulk delete</v-btn>
          <v-btn class="button" :disabled="bulkActionTouchpoint.length === 0" :loading="deactivateStageL" color="#10b981 " @click="deactivateStage(null, 'bulk')">Bulk deactivate</v-btn>
          <v-btn class="button" :disabled="bulkActionTouchpoint.length === 0" color="#10b981 " @click="chatFromUserDialog = true">Bulk activate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="insertImageDialog" max-width="400">
  <v-card>
    <v-card-title class="headline">Insert Image</v-card-title>
    <v-card-text>
      <v-text-field
        v-model="insertImageUrl"
        label="Paste your S3 image URL here"
        outlined
        dense
        autofocus
        :rules="[
          v => !!v || 'Image URL is required',
          v => /^https?:\/\/.+\.(jpg|jpeg|png|gif|webp|svg)$/i.test(v) || 'Enter a valid image URL'
        ]"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="insertImageDialog = false">Cancel</v-btn>
      <v-btn color="primary" @click="confirmInsertImage" :disabled="!insertImageUrl">Insert</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <v-dialog v-model="bulkEmailDialog" max-width="800px"
      persistent
      scrollable
      transition="dialog-transition">
      <v-card v-if="emailpage === 1" style="max-width:800px;">
        <v-card-title>
          <span class="headline">Bulk action emails</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-subtitle>
          Please select emails on which you want to take bulk action.
        </v-card-subtitle>
        <v-card-text style="height: 400px;" v-if="loaderforActionBulk">
          <amara-loader></amara-loader>
        </v-card-text>
        <v-card-text style="height: 500px;" v-if="!loaderforActionBulk">
          <v-row style="height: 80px; overflow-y:auto;">
        <v-col cols="6" class="text-left" style="align-self: center">
          <span v-if="filteredCompanyTouchpointsBulk.length === 0">No available touchpoints for bulk edit</span>
           <v-checkbox
           v-if="filteredCompanyTouchpointsBulk.length > 0"
            v-model="selectAlltouchpoints"
            label="Select all"
            style="margin:0px !important"
            hide-details
            @change="selectAlltouchpoints === true ? templateId = filteredCompanyTouchpointsBulk : templateId = []"
          ></v-checkbox>
        </v-col>
          </v-row>
          <v-row no-gutters class="px-3" style="height: 420px; overflow-y:auto;" v-if="filteredCompanyTouchpointsBulk.length > 0">
        <v-col cols="4"
          v-for="(col, index) in filteredCompanyTouchpointsBulk"
          :key="index"
        >
          <v-checkbox
            :id="index.toString()"
            hide-details
            v-model="templateId"
            :label="col.stage_details.title"
            :value="col"
          ></v-checkbox>
        </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn class="button" @click="bulkEmailDialog = false;selectAlltouchpoints = false;templateId = [];bodyEmail = '';emailAddress = '';subjectEmail = '';">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="button" :disabled="!templateId.length" color="#10b981 " @click="emailpage = 2;type=1;selectAlltouchpoints = false">Assign Sender</v-btn>
          <v-btn class="button" :disabled="!templateId.length" color="#10b981 " @click="emailpage = 2;type=2;selectedTemplate = null;getemailtemplate();selectAlltouchpoints = false">Assign Content</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="emailpage === 2" style="max-width:800px;">
        <v-card-title>
            <span class="headline">{{ type === 1 ? 'Action Sender' : 'Action email' }}</span>
          <v-spacer></v-spacer>
          <div  class="mr-2" v-if="(type === 2 || type === 3) && multi_language_support_option">
        <v-select
          v-model="multi_language_support"
            :items="[true, false]"
          label="Multi Language Support"
          dense
          outlined
          attach
          placeholder="Language Support"
          style="max-width: 180px;position:relative;top:15px;"
          :menu-props="{ top:false, offsetY: true }"
          @change="changeMultiLanguage()"
        ></v-select>
      </div>
      <div class="mr-2" v-if="multi_language_support && (type === 2 || type === 3)">
        <v-select
          v-model="template_language"
          :items="['English', 'Malay', 'Thai', 'Filipino']"
          label="Language"
          dense
          outlined
          attach
          placeholder="Select language"
          style="max-width: 150px;position:relative;top:15px;"
          :menu-props="{ top:false, offsetY: true }"
          @change="changelanguage()"
        ></v-select>
      </div>
          <v-select 
            v-if="type === 2 || type === 3"
            outlined
            dense
            hide-details
            :items="templateOptions"
            :item-text="item => item.templateTrigger.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())"
            label="Select email template"
            v-model="selectedTemplate"
            @change="applyTemplate"
            return-object
            style="max-width: 200px;text-align: center;"
            :menu-props="{top:false,offsetY:true }"
          ></v-select>
        </v-card-title>
        <v-card-subtitle>
        <template v-if="type !== 1 && !emailData">
          This touchpoint has no assigned email template.
        </template>
        <template v-else>
          {{ type === 1 ? 'Please enter senders email' : 'Please enter email template details.' }}
        </template>
        </v-card-subtitle>  
        <v-card-text>
          <v-form
        ref="form"
        v-model="valid"
        lazy-validation
          >
          <v-flex xs12 v-if = "type === 1 || type === 3">
            <label>From</label>
            <v-text-field
              placeholder="Amara <hello@amara.ai>"
              outlined :rules="senderRules"
              dense
              v-model="emailAddress"
              name="email"
            ></v-text-field>
          </v-flex>
        <v-flex xs12 v-if = "type === 2 || type === 3">
          <v-menu
             v-model="menu3"
            :close-on-content-click="false"
            :nudge-width="300"
            offset-y
            left
            style="max-width:600px;z-index: 99999;"
          >
            <template v-slot:activator="{ on, attrs }">
          <p
            style="float: right; margin: 0px 5px;"
            outlined
            dark
            v-bind="attrs"
            v-on="on"
          >
            Insert placeholder
          </p>
            </template>
            <v-card>
          <v-list>
            <label class="ml-4">Subject placeholder</label>
            <v-tabs
              vertical
              class="text-left mt-2"
              style="border-top: 1px solid rgba(0, 0, 0, 0.12);"
            >
              <v-tab
            v-for="(plc, p) in placeholders"
            :key="p"
            class="text-left"
            style="display: inline-table; border-right: 1px solid #10b981 ; font-size: 12px; padding-top: 16px;"
              >
            {{ p }}
              </v-tab>
              <v-tab-item
            class="pa-2 pt-3"
            v-for="(plc, p) in placeholders"
            :key="p"
              >
            <p
              style="margin: 0 20px 10px 0; display: inline-flex; line-height: 18px; border-radius: 6px; padding: 5px 10px; cursor: pointer; background: rgb(237, 237, 237); font-size: 13px;"
              v-for="(plc1, p1) in plc"
              :key="p1"
              @click="addName(plc1)"
            >
              {{ plc1 }}
            </p>
              </v-tab-item>
            </v-tabs>
          </v-list>
            </v-card>
          </v-menu>
          <label>Subject*</label>
          <v-text-field
            placeholder="Enter mail subject"
            outlined
            dense
            ref="my"
            v-model="subjectEmail"
            name="subject"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 v-if = "type === 2 || type === 3">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-width="300"
            offset-y
            left
            style="max-width:600px;z-index: 99999;"
          >
            <template v-slot:activator="{ on, attrs }">
          <p
            style="float: right; margin: 0px 5px;"
            color="primary"
            outlined
            dark
            v-bind="attrs"
            v-on="on"
          >
            Insert placeholder
          </p>
            </template>
            <v-card >
          <v-list >
            <label class="ml-4">Body placeholder</label>
            <v-tabs
              vertical
              class="text-left mt-2"
              style="border-top: 1px solid rgba(0, 0, 0, 0.12);"
            >
              <v-tab
            v-for="(plc, p) in placeholders"
            :key="p"
            class="text-left"
            style="display: inline-table; border-right: 1px solid #10b981 ; font-size: 12px; padding-top: 16px;"
              >
            {{ p }}
              </v-tab>
              <v-tab-item
            class="pa-2 pt-3"
            v-for="(plc, p) in placeholders"
            :key="p"
              >
            <p
              style="margin: 0 20px 10px 0; display: inline-flex; line-height: 18px; border-radius: 6px; padding: 5px 10px; cursor: pointer; background: rgb(237, 237, 237); font-size: 13px;"
              v-for="(plc1, p1) in plc"
              :key="p1"
              @click="insertPlaceholder(plc1)"
            >
              {{ plc1 }}
            </p>
              </v-tab-item>
            </v-tabs>
          </v-list>
            </v-card>
          </v-menu>
          <label>Body*</label>
          <quill-editor
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
            ref="myQuillEditor"
            class="quill-editor-1 my-quill"
            name="body"
            data-vv-as="description"
            v-model="bodyEmail"
            :options="editorOption"
          >
            <div id="toolbar" slot="toolbar" style="border-radius: 8px 8px 0 0;">
          <button class="ql-bold">Bold</button>
          <button class="ql-italic">Italic</button>
          <button class="ql-underline">Underline</button>
          <button class="ql-strike">Strike</button>
          <button class="ql-header" value="1">Header 1</button>
          <button class="ql-header" value="2">Header 2</button>
          <button class="ql-blockquote">Blockquote</button>
          <button class="ql-list" value="ordered">Ordered List</button>
          <button class="ql-list" value="bullet">Bullet List</button>
            <button type="button" @click="insertImagePrompt" class="ql-custom-image-btn" style="background: none; border: none; cursor: pointer;">
              <v-icon small style="margin-bottom:5px;">mdi-link-variant</v-icon>
            </button>
            </div>
          </quill-editor>
          <div class="mt-4">
            <quill-editor
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
          ref="myQuillEditor1"
          class="quill-editor-2 my-quill"
          name="body"
          data-vv-as="description"
          v-model="bodyEmail1"
          :options="editorOption"
            ></quill-editor>
          </div>
        </v-flex>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn text depressed @click="bulkEmailDialog = false;selectedTemplate = null;selectAlltouchpoints = false;templateId = [];bodyEmail = '';emailAddress = '';subjectEmail = '';">
        Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="button" :loading="isLoading" depressed @click="validate()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="400px"
      v-model="chatFromUserDialog" persistent
      scrollable
      transition="dialog-transition"
    >
    <v-card>
        <v-card-title>
          Chat from user
        </v-card-title>
        <v-card-subtitle>
          Please select chat from user.
        </v-card-subtitle>
        <v-card-text>
          <v-row class="mb-4">
            <v-col cols="12" class="text-center" style="align-self: center">
              <v-autocomplete :items="companyAdmins" style="width: 270px;"
              item-text="display_name"
              item-value="user_id"
              placeholder="Chat from user"
              hide-details
              required class="pa-0 ma-0" outlined dense v-model="bulkChatUser">
            </v-autocomplete>
            </v-col>
        </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn outlined @click="chatFromUserDialog = false;liveStageL = false;">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="liveStageL"  @click="liveStage('bulk')">Activate</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    <add-company v-if="editCompanyView" ref="addcompany" @updateCompanyEditView="handleUpdate" @getCompanyDetailsUpdate="getCompanyDetails" />
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import dayjs from 'dayjs';
import Vue from 'vue';
import { mapState } from 'vuex';
// import relativeTime from 'dayjs/plugin/relativeTime';
// import customParseFormat from 'dayjs-ext/plugin/customParseFormat';
import moment from 'moment';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
import draggable from "vuedraggable";
import companySummary from './companySummary.vue';
import companyVault from './compnayVault.vue';
import emailTemplate from './emailTemplate';
import welcomeintend from './welcomeintend';
import inboundstatements from './inboundstatements.vue';
import addAdmin from './dialogs/AddAdmin';
import companyLog from './companyLog.vue';
import addCompany from './dialogs/AddCompany';
import addTouchpoint from './dialogs/AddTouchpoint';
import stageDetails from './dialogs/StageDetails';
import AmaraLoader from './elements/amara-loader';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);


Vue.use(VueSweetalert2);
  export default {
    name: 'HelloWorld',

    components: {
      axios,
      dayjs,
      // relativeTime,
      // customParseFormat,
      addCompany,
      emailTemplate,
      welcomeintend,
      inboundstatements,
      addTouchpoint,
      stageDetails,
      addAdmin,
      companyLog,
      companyVault,
      companySummary,
      draggable,
      quillEditor,
      AmaraLoader
    },

    data: () => ({
      tabsettings: 'c_email_template',
      editCompanyView: false,
      activeTab: 'details',
      reportItem: [
        {
          label: 'All chat',
          value: 'all'
        },
        {
          label: 'Latest completed chat',
          value: 'latest'
        }
      ],
      senderRules: [
        v => !v || /^(?:[A-Za-z\s]+<[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}>|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})$/.test(v) || 'Sender must be valid',
      ],
      languageConfigured: 'en',
      languageItem: [
        { text: 'English', value: 'en' },
        { text: 'English & Malay', value: 'en,ms' },
      ],
      languageMap: {
        en: "English",
        th: "Thai",
        ml: "Malayalam",
        tl: "Filipino"
      },
      reportType: 'all',
      isLoadingData: false,
      multi_language_support: false,
      template_language: 'en',
      store_template: '',
      completionMenu: false,
      reportTypeFeedback: 'culture_dashboard',
      langDialog: false,
      emailData: null,
      emailpage: 0,
      type: 0,
      insertImageDialog: false,
      insertImageUrl: '',
      reportloading: false,
      dialogOpen: false,
      deactivateStageL: false,
      liveStageL: false,
      subjectEmail: '',
      deleteStageL: false,
      chatFromUserDialog: false,
      loaderforAction: false,
      loaderforActionBulk: false,
      bodyEmail1: "<p>Best Regards,<br/>{{Session.stage.chatFromUser.display_name}}</p>",
      bodyEmail2: '',
      touchpoint_stage_id: '',
      sortBy: '',
      config: {
        editable: false,
        initialLoading: true,
        loading: false,
        initialLoadingFilters: true,
        newLogo: null,
        logoPreview: null,
        activeIndex: 0
      },
      editorOption: {
          modules: {
            toolbar: '#toolbar'
          },
          placeholder: 'Type here ...'
        },
        editorOption1: {
          modules: {
            toolbar: '#toolbar'
          },
          placeholder: 'Type here ...'
        },
         placeholders: {"Session Details":{
        "Employee display name": "{{Session.user.display_name}}",
        "Employee first name": "{{Session.user.first_name}}",
        "Employee last name": "{{Session.user.last_name}}",
        "Employee email": "{{Session.user.email}}",
        "Employee company name": "{{Session.company.company_name}}"
    }},
      items: [{
        name: 'Shortest to longest duration',
        value: 'increasing_duration'
      }, {
        name: 'Longest to shortest duration',
        value: 'decreasing_duration'
      }],
      bulkChatUser: '',
      emailAddress: '',
      templateId: [],
      reportDialog: false,
      bulkActionEmails: [],
      bulkEmailDialog: false,
      bulkActionTouchpoint: [],
      companyAdminsParent: [],
      companyTouchpointsBulk: [],
      selectAll: false,
      selectAlltouchpoints: false,
      blacklistAction: [
          {
            title: 'Bulk activate touchpoint',
            value: 1
          }, {
            title: 'Bulk deactivate touchpoint',
            value: 2
          }, {
            title: 'Bulk delete touchpoint',
            value: 3
          }
        ],
        templateOptions: [],
      selectedTemplate: null,
      moment: moment,
      menu: false,
      isLoading: false,
      totalCount: '',
      bodyEmail: '',
      avatarList: [],
      driverList: [],
      updatedList: {},
      touchpointList: [],
      logDetails: false,
      dialogSorting: false,
      insertImageSelection: null,
      logData: [],
      question: [],
      auditLog: [],
      data: [],
      multi_language_support_option: false,
      selectedDriver: '',
      selectedSubDriver: '',
      subdriverName: '',
      subDriverDescription: '',
      integrations: [{ name: 'Slack', value: 'slack' }, { name: 'Microsoft Teams', value: 'ms_teams' }],
      pagination: {
        page: 1,
        rowsPerPage: 20
      },
      subdriverDialog: false,
      GenAIItem: [{
        name: 'Export GenAI report',
        value: "{'export_genai_report': ['employee_summary']}"
      }],
      autoAssignItem: [{
        name: 'HR Manager',
        value: 'hr_manager'
      }, {
        name: 'HRBP',
        value: 'hrbp'
      }],
      LinkItem: [{
        name: 'Glassdoor',
        value: 'glassdoor_link'
      }, {
        name: 'JobStreet',
        value: 'jobStreet_link'
      }, {
        name: 'Linkedin',
        value: 'linkedin_link'
      }, {
        name: 'Facebook',
        value: 'facebook_link'
      }],
       chatCompletion: {
        startDate: undefined,
        endDate: undefined,
        format: 'DD/MM/YYYY',
        minDate: dayjs('01/01/2018').format(),
        maxDate: dayjs().format(),
        presets: [
          {
            label: 'Last 7 Days',
            range1: 'this_week',
            range: [
              dayjs().subtract(6, 'day').format(),
              dayjs().format()
            ]
          },
          {
            label: 'Last 1 Month',
            range1: 'last_month',
            range: [
              dayjs().subtract(1, 'month').add(1, 'day').format(),
              dayjs().format()
            ]
          },
          {
            label: 'Last 3 Months',
            range1: 'last_3_months',
            range: [
              dayjs().subtract(3, 'month').add(1, 'day').format(),
              dayjs().format()
            ]
          },
          {
            label: 'Last 6 Months',
            range1: 'last_6_months',
            range: [
              dayjs().subtract(6, 'month').add(1, 'day').format(),
              dayjs().format()
            ]
          },
          {
            label: 'Last 12 Months',
            range1: 'last_12_months',
            range: [
              dayjs().subtract(12, 'month').add(1, 'day').format(),
              dayjs().format()
            ]
          }
        ],
        dateRange: {
          startDate: dayjs().format('DD/MM'),
          endDate: dayjs().format('DD/MM')
        }
      },
      tabs: null,
      editView: false,
      loading: false,
      menu1: false,
      menu3:false,
      companyData: null,
      completionDates: [],
      chatCompleteDateModel: '',
      companyTouchpoints: [],
      selectedStage: '',
      companyAdmins: [],
      companyDataOld: [],
      planOld: [],
      settingsOld: [],
      company: {},
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    }),
  computed: {
    filteredCompanyTouchpointsBulk() {
      return this.companyTouchpointsBulk.filter(
        col => col.stage_details && col.stage_details.email_template_id
      );
    },
    ...mapState({
      snackbar: state => state.snackbar,
      user: state => state.user
    }),
    getPreNumber () {
      const num = (this.pagination.page - 1) * 20 + 1;
      if (num > this.totalCount) {
        return this.totalCount;
      }
      return num;
    },
    getNextNumber () {
      const num = (this.pagination.page - 1) * 20 + 20;
      if (num > this.totalCount) {
        return this.totalCount;
      }
      return num;
    }
  },
    methods: { 
      handleUpdate () {
        this.editCompanyView = false;
      },
       updateChatCompleteDate (date) {
      if (date) {
        this.chatCompletion.startDate = date[0];
        this.chatCompletion.endDate = date[1];
      }
    },
    clearModeldateComp () {
      setTimeout(() => {
        if (this.completionDates.length === 0) {
          this.chatCompleteDateModel = '';
        }
      }, 200);
    },
     resetComDate () {
      this.chatCompletion.startDate = undefined;
      this.chatCompletion.endDate = undefined;
      this.chatCompleteDateModel = '';
      this.completionDates = [];
    },
      changeMultiLanguage () {
        if (!this.multi_language_support) {
          this.template_language = 'English';
          this.subjectEmail = this.store_template.subject;
          this.bodyEmail = this.store_template.body.body_1;
          this.bodyEmail1 = this.store_template.body.body_2;
        }
      },
      changelanguage () {
        if (this.multi_language_support){
          if (this.template_language === 'English'){
            this.subjectEmail = this.store_template.subject;
            this.bodyEmail = this.store_template.body.body_1;
            this.bodyEmail1 = this.store_template.body.body_2;
          } else if (this.template_language === 'Malay' && this.store_template.body_ms) {
            this.subjectEmail = this.store_template.subject_ms;
            this.bodyEmail = this.store_template.body_ms.body_1;
            this.bodyEmail1 = this.store_template.body_ms.body_2;
          } else if (this.template_language === 'Thai' && this.store_template.body_th) {
            this.subjectEmail = this.store_template.subject_th;
            this.bodyEmail = this.store_template.body_th.body_1;
            this.bodyEmail1 = this.store_template.body_th.body_2;
          } else if (this.template_language === 'Filipino' && this.store_template.body_tl) {
            this.subjectEmail = this.store_template.subject_tl;
            this.bodyEmail = this.store_template.body_tl.body_1;
            this.bodyEmail1 = this.store_template.body_tl.body_2;
          } else {
            this.subjectEmail = '';
            this.bodyEmail = '';
          }
        }
      },
      insertImagePrompt() {
        const quill = this.$refs.myQuillEditor.quill;
        const range = quill.getSelection();
        this.insertImageSelection = range ? range.index : null;
        this.insertImageUrl = '';
        this.insertImageDialog = true;
      },
      confirmInsertImage() {
        if (this.insertImageUrl) {
          const quill = this.$refs.myQuillEditor.quill;
          const index = this.insertImageSelection !== null ? this.insertImageSelection : quill.getLength();
          quill.insertEmbed(index, 'image', this.insertImageUrl, 'user');
          this.insertImageDialog = false;
          this.insertImageUrl = '';
          this.insertImageSelection = null;
        }
      },
      validate () {
        if (this.type === 3) {
        this.$refs.form.validate()
        setTimeout(() => {
          if (this.valid && this.bodyEmail.length > 0) {
            this.updateEmail();
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Subject and body is mandatory field!'
            });
          }
        }, 2000);
      } else if (this.type === 1) {
          this.updatebulkEmail();
        } else if (this.type === 2) {
           this.$refs.form.validate()
        setTimeout(() => {
          if (this.valid && this.bodyEmail.length > 0) {
            this.updatebulkEmail();
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Subject and body is mandatory field!'
            });
          }
        }, 2000);
        }
      },
      updatebulkEmail () {
          let templateIds = [];
          if (Array.isArray(this.templateId)) {
            templateIds = this.templateId
              .map(item => item.stage_details && item.stage_details.email_template_id)
              .filter(id => !!id);
          } else if (this.templateId && this.templateId.stage_details && this.templateId.stage_details.email_template_id) {
            templateIds = [this.templateId.stage_details.email_template_id];
          }
          this.templateId = templateIds;
        if (this.type === 1) {
          axios.patch(`${process.env.VUE_APP_API_URL}company/templates/${this.$route.query.cid}`, {
        template_ids: this.templateId,
        sender: this.emailAddress || null,
      }, {
        withCredentials: true
      }).then((response) => {
        if (response && response.data) {
          this.bulkEmailDialog = false;
          this.bodyEmail = '';
          this.subjectEmail = '';
          this.bodyEmail1 = "<p>Best Regards,<br/>{{Session.stage.chatFromUser.display_name}}</p>";
          this.templateId = [];
          this.emailAddress = '';
          this.getstagesBulk(this.$route.query.cid);
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'Email template updated successfully!'
          });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch template, Please try again later!'
          });
        }
      });
        }
        if (this.type === 2) {
          const temp = {
            body_1: this.cleanEmailHtml(this.bodyEmail),
            body_2: this.cleanEmailHtml(this.bodyEmail1),
            body_sub: this.cleanEmailHtml(this.bodyEmail2),
          };
          let bodyField = 'body';
      let subjectField = 'subject';
      if (this.template_language === 'Malay') {
        bodyField = 'body_ms';
        subjectField = 'subject_ms';
      } else if (this.template_language === 'Filipino') {
        bodyField = 'body_tl';
        subjectField = 'subject_tl';
      } else if (this.template_language === 'Thai') {
        bodyField = 'body_th';
        subjectField = 'subject_th';
      }
          axios.patch(`${process.env.VUE_APP_API_URL}company/templates/${this.$route.query.cid}`, {
            [subjectField]: this.subjectEmail,
            template_ids: this.templateId,
            multi_language_enabled: this.multi_language_support,
            [bodyField]: temp
          }, {
            withCredentials: true
          }).then((response) => {
            if (response && response.data) {
              this.bulkEmailDialog = false;
              this.bodyEmail = '';
              this.subjectEmail = '';
              this.bodyEmail1 = "<p>Best Regards,<br/>{{Session.stage.chatFromUser.display_name}}</p>";
              this.templateId = [];
              this.emailAddress = '';
              this.getstagesBulk(this.$route.query.cid);
              this.$store.dispatch('updateSnackbar', {
                color: 'success',
                show: true,
                text: 'Email template updated successfully!'
              });
            }
          }).catch((err) => {
            if (err.response.status === 429) {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: err.response.data.error
              });
            } else {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: 'Unable to fetch template, Please try again later!'
              });
            }
          });
        }
      },
      cleanEmailHtml (html) {
      return html
        .replace(/<p([^>]*)>/g, '<p$1 style="margin:0;padding:0;">')
        .replace(/<div([^>]*)>/g, '<div$1 style="margin:0;padding:0;">');
        },
       updateEmail () {
        this.isLoading = true;
      const temp = {
        body_1: this.cleanEmailHtml(this.bodyEmail),
        body_2: this.cleanEmailHtml(this.bodyEmail1),
        body_sub: this.cleanEmailHtml(this.bodyEmail2),
      };
      let bodyField = 'body';
      let subjectField = 'subject';

      if (this.template_language === 'Malay') {
        bodyField = 'body_ms';
        subjectField = 'subject_ms';
      } else if (this.template_language === 'English') {
        bodyField = 'body';
        subjectField = 'subject';
      } else if (this.template_language === 'Filipino') {
        bodyField = 'body_tl';
        subjectField = 'subject_tl';
      } else if (this.template_language === 'Thai') {
        bodyField = 'body_th';
        subjectField = 'subject_th';
      }
      if (!this.templateId || (Array.isArray(this.templateId) && this.templateId.length === 0)) {
        axios.post(`${process.env.VUE_APP_API_URL}company/templates/${this.$route.query.cid}`, {
          [subjectField]: this.subjectEmail,
          stage_id: this.touchpoint_stage_id,
          sender: this.emailAddress || null,
          multi_language_enabled: this.multi_language_support,
          [bodyField]: temp
        }, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.bulkEmailDialog = false;
            this.bodyEmail = '';
            this.subjectEmail = '';
            this.bodyEmail1 = "<p>Best Regards,<br/>{{Session.stage.chatFromUser.display_name}}</p>";
            this.templateId = [];
            this.emailData = null;
            this.emailAddress = '';
            this.getstagesBulk(this.$route.query.cid);
            this.getSatges(this.$route.query.cid);
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Email template updated successfully!'
            });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch template, Please try again later!'
          });
        }
      })
      .finally(() => {
      this.isLoading = false;
    });
      } else {
        axios.patch(`${process.env.VUE_APP_API_URL}company/templates/${this.$route.query.cid}`, {
          [subjectField]: this.subjectEmail,
          template_ids: this.templateId,
          sender: this.emailAddress || null,
          multi_language_enabled: this.multi_language_support,
          [bodyField]: temp
        }, {
          withCredentials: true
        }).then((response) => {
        if (response && response.data) {
          this.bulkEmailDialog = false;
          this.bodyEmail = '';
          this.subjectEmail = '';
          this.bodyEmail1 = "<p>Best Regards,<br/>{{Session.stage.chatFromUser.display_name}}</p>";
          this.templateId = [];
          this.emailData = null;
          this.emailAddress = '';
          this.getstagesBulk(this.$route.query.cid);
          this.getSatges(this.$route.query.cid);
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'Email template updated successfully!'
          });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch template, Please try again later!'
          });
        }
      }).finally(() => {
      this.isLoading = false;
    });
      }
    },
    editemail (details) {
       this.emailpage = 2; 
       this.bulkEmailDialog = true;
       this.type = 3;
       this.selectedTemplate = null;
       this.getemailtemplate();
       this.bulkActionEmails = [details.id];
       this.touchpoint_stage_id = details.id;
      if (details.email_template_id !== null) {
      const queryParams = {
      count: 'true',
      template_id: details.email_template_id,
    };
      axios.get(`${process.env.VUE_APP_API_URL}company/templates/${this.$route.query.cid}?count=true`, {
        params: queryParams,
        withCredentials: true
      }).then((response) => {
        if (response && response.data) {
          this.multi_language_support_option = true;
          this.store_template = response.data.templates_details[0];
          this.template_language="English";
          this.multi_language_support = response.data.templates_details[0].multi_language_enabled;
          this.emailData = response.data.templates_details;
          if (this.emailData && this.emailData.length > 0) {
            this.subjectEmail = this.emailData[0].subject;
            if (Array.isArray(this.templateId)) {
              this.templateId[0] = this.emailData[0].id;
            }
            this.bodyEmail = this.emailData[0].body.body_1;
            this.bodyEmail1 = this.emailData[0].body.body_2;
            if (this.emailData[0].sender && this.emailData[0].sender !== 'None' && this.emailData[0].sender !== 'none') {
              this.emailAddress = this.emailData[0].sender;
            } else {
              this.emailAddress = '';
            }
          }
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.config.savingStage = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
        }
      });
    } else {
      this.multi_language_support = false;
      this.multi_language_support_option = false;
      this.template_language = 'English';
    }
    },
    getemailtemplate () {
      const queryParams = {
      count: 'true',
      template_trigger_ref: 'default_',
      canned_email_templates: 'true',
    };
      axios.get(`${process.env.VUE_APP_API_URL}company/templates/${this.$route.query.cid}?count=true`, {
        params: queryParams,
        withCredentials: true
      }).then((response) => {
        if (response && response.data) {
          this.templateOptions = response.data.templates_details;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.config.savingStage = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
        }
      });
    },
      sortByNew () {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        let url = '';
        if (this.sortBy) {
          url = `${process.env.VUE_APP_API_URL}stage/list/${this.$route.query.cid}?count=true&stageType__in=lifecycle&fields=id,title&sorting=${this.sortBy}`
        } else {
          url = `${process.env.VUE_APP_API_URL}stage/list/${this.$route.query.cid}?count=true&stageType__in=lifecycle&fields=id,title`
        }

        axios.get(url, {
          withCredentials: true
        }).then((response) => {
          if (response.data ) {
            this.touchpointList = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch audit logs, Please try again later!'
            });
          }
        });
      },
      onEditorFocus(quill) {
      if (quill.getSelection()) {
        this.config.activeIndex = quill.getSelection().index;
      }
    },
    onEditorChange(q) {
      if (q.quill.getSelection()) {
        this.config.activeIndex = q.quill.getSelection().index;
      }
    },
    insertPlaceholder(p) {
      this.menu1 = false;
      const quill = this.$refs.myQuillEditor.quill;
      quill.insertText(this.config.activeIndex, p, '', true);
    },
    onEditorFocus12(quill) {
      if (quill.getSelection()) {
        this.config.activeIndex = quill.getSelection().index;
      }
    },
    onEditorChange12(q) {
      if (q.quill.getSelection()) {
        this.config.activeIndex = q.quill.getSelection().index;
      }
    },
    insertPlaceholder12(p) {
      this.menu3 = false;
      const quill = this.$refs.myQuillEditor12.quill;
      quill.insertText(this.config.activeIndex, p, '', true);
    },
    addName (plc) {
      this.menu3 = false;
      const { subjectEmail } = this;
      const textarea = this.$refs.my.$refs.input;
      const index = textarea.selectionStart;
      const name = `${plc}`;

      this.subjectEmail = `${subjectEmail.substring(0, index)}${name}${subjectEmail.substring(
        index
      )}`;
      textarea.focus();
      setTimeout(() => {
        textarea.selectionStart = index + name.length;
        textarea.selectionEnd = index + name.length;
      });
    },
    addName12 (plc) {
      this.menu2 = false;
      const { subjectCalendarEmail } = this;
      const textarea = this.$refs.my12.$refs.input;
      const index = textarea.selectionStart;
      const name = `${plc}`;

      this.subjectCalendarEmail = `${subjectCalendarEmail.substring(0, index)}${name}${subjectCalendarEmail.substring(
        index
      )}`;
      textarea.focus();
      setTimeout(() => {
        textarea.selectionStart = index + name.length;
        textarea.selectionEnd = index + name.length;
      });
    },
    addNamenew (plc1) {
      const { bodyEmail } = this;
      const textarea = this.$refs.my1.$refs.input;
      const index = textarea.selectionStart;
      const name = `${plc1}`;

      this.bodyEmail = `${bodyEmail.substring(0, index)}${name}${bodyEmail.substring(
        index
      )}`;
      textarea.focus();
      setTimeout(() => {
        textarea.selectionStart = index + name.length;
        textarea.selectionEnd = index + name.length;
      });
    },
    edit () {
        this.openView = true;
    },
    save () {
        this.listview = true;
        this.openView = false;
        this.editview = false;
        this.bodyEmail = '',
        this.subjectEmail = '',
        this.templateName = ''
    },
    some (event) {
        let textarea = this.$refs.yourTextarea.selectionStart;
        let cursorPosition = textarea.selectionStart
    },
      deactivateStage (id1, item) {
        this.$swal({
          title: 'Are you sure?',
          text: "You want to deactivate this touchpoint!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, deactivate it!'
        }).then((result) => {
          if (result.isConfirmed) {
            this.deactivateStageL = true;
            this.selectedStage = id1;
            let temp = [];
            if (item === 'bulk') {
              const touchpoint = this.bulkActionTouchpoint;
              this.$lodash.each(touchpoint, (val, i) => {
                let temp1 = {}
                temp1.stage_id = val.stage_details.id,
                temp1.status = "draft"
                temp.push(temp1);
              });
            } else {
                let temp1 = {}
                temp1.stage_id = this.selectedStage,
                temp1.status = "draft"
                temp.push(temp1);
            }
            // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
            axios.patch(`${process.env.VUE_APP_API_URL}stage/bulk-update/`, {
                updated_stages: temp
            }, {
              withCredentials: true
            }).then((response) => {
              if (response && response.data) {
                  this.reportDialog = false;
                  this.getSatges(this.$route.query.cid);
                  this.getstagesBulk(this.$route.query.cid);
                  this.$store.dispatch('updateSnackbar', {
                    color: 'success',
                    show: true,
                    text: 'Touchpoint deactivated successfully!'
                  });
                // this.$refs.stagedetails.stageDialog = true;
                // this.$refs.stagedetails.stageData = response.data;
                // console.log(this.company);
              }
            }).catch((err) => {
              this.deactivateStageL = false;
              this.liveStageL = false;
              this.deleteStageL = false;
              if (err.response.status === 429) {
                this.config.savingStage = false;
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.error
                });
              } else if (err.response.status === 400) {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.message
                });
              } else {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: 'Unable to fetch details, Please try again later!'
                });
              }
            });
          }
        });
        },
      deleteStage (id1, item) {
        this.$swal({
          title: 'Are you sure?',
          text: "You want to delete this touchpoint!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteStageL = true;
            this.selectedStage = id1;
            let temp = [];
            if (item === 'bulk') {
              const touchpoint = this.bulkActionTouchpoint;
              this.$lodash.each(touchpoint, (val, i) => {
                let temp1 = {}
                temp1.stage_id = val.stage_details.id,
                temp.push(temp1);
              });
            } else {
                let temp1 = {}
                temp1.stage_id = this.selectedStage,
                temp.push(temp1);
            }
            // console.log('teststtsst', temp);
            let updated_stages = {
              updated_stages: temp
            }
            // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
            axios.delete(`${process.env.VUE_APP_API_URL}stage/bulk-delete/`, {
              data: {
                  updated_stages: temp
              }
              }, {
                withCredentials: true
              }).then((response) => {
              if (response && response.data) {
                this.reportDialog = false;
                  this.getSatges(this.$route.query.cid);
                  this.getstagesBulk(this.$route.query.cid);
                  this.$store.dispatch('updateSnackbar', {
                    color: 'success',
                    show: true,
                    text: 'Touchpoint deactivated successfully!'
                  });
              }
            }).catch((err) => {
              this.deactivateStageL = false;
              this.liveStageL = false;
              this.deleteStageL = false;
              if (err.response.status === 429) {
                this.config.savingStage = false;
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.error
                });
              } else if (err.response.status === 400) {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.message
                });
              } else {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: 'Unable to fetch details, Please try again later!'
                });
              }
            });
          }
        });
        },
      applyTemplate() {
        if (this.selectedTemplate) {
          this.subjectEmail = this.selectedTemplate.subject;
          this.bodyEmail = this.selectedTemplate.body.body_1;
          this.bodyEmail1 = this.selectedTemplate.body.body_2;
        }
      },
      liveStage (item) {
        this.liveStageL = true;
        if (this.bulkChatUser) {
        let temp = [];
        if (item === 'bulk') {
          const touchpoint = this.bulkActionTouchpoint;
          this.$lodash.each(touchpoint, (val, i) => {
            let temp1 = {}
            temp1.chatFromUser_id = this.bulkChatUser,
            temp1.stage_id = val.stage_details.id,
            temp1.status = "live"
            temp.push(temp1);
          });
        } else {
            let temp1 = {}
            temp1.chatFromUser_id = this.chat_on_behalf,
            temp1.stage_id = this.$parent.selectedStage,
            temp1.status = "live"
            temp.push(temp1);
        }
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.patch(`${process.env.VUE_APP_API_URL}stage/bulk-update/`, {
          updated_stages: temp
        }, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.reportDialog = false;
            this.chatFromUserDialog = false;
            this.getSatges(this.$route.query.cid);
            this.getstagesBulk(this.$route.query.cid);
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Touchpoint activated!'
            });
          }
        }).catch((err) => {
          this.deactivateStageL = false;
          this.liveStageL = false;
          this.deleteStageL = false;
          if (err.response.status === 429) {
            this.loading = false;
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else if (err.response.status === 400) {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.message
                });
              } else {
            this.loading = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
        } else {
          this.liveStageL = false;
          this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Please select chat from user!'
            });
        }
      },
      bulkActionCheck (value) {
        this.reportDialog = true;
      },
      onEnd () {
      },
      saveSortList () {
        const temp = {};
        this.$lodash.each(this.touchpointList.data, (val, i) => {
            temp[`${val.stage_details.id}`] = i
          });
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.patch(`${process.env.VUE_APP_API_URL}stage/update/index/${this.$route.query.cid}`, {
          'updated_index_dict': temp
        }, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.getSatges(this.$route.query.cid);
            this.dialogSorting = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Touchpoint index updated successfully!'
            });
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to update touchpoint index, Please try again later!'
            });
          }
        });
      },
      downloadTouchpointSheet (link) {
        setTimeout(() => {
          window.open(link);
        }, 100);
      },
      getAvatarAudit (a) {
        let avatar = '';
        this.$lodash.each(this.avatarList, (val, i) => {
          if (val.id == a) {
            avatar = val.avatar;
          }
        });
        return avatar;
      },
      displayPre () {
        if (this.pagination.page > 1) {
          this.pagination.page = this.pagination.page - 1;
          this.getAuditLog()
        }
      },
      displayNext () {
        if (this.pagination.page < (this.totalCount / 20)) {
          this.pagination.page = this.pagination.page + 1;
          this.getAuditLog()
        }
      },
      getAuditLog ($state) {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/audit`, {
          params: {
            'page_offset': this.pagination.page,
            'page_limit': this.pagination.rowsPerPage,
            'company_id': this.$route.query.cid
          },
          withCredentials: true
        }).then((response) => {
          if (response.data && response.data.count ) {
            this.totalCount = response.data.count;
          }
          if (response && response.data && response.data.results) {
            this.auditLog = response.data.results;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch audit logs, Please try again later!'
            });
          }
        });
      },
      infiniteHandler ($state) {
        this.getAuditLog($state);
      },
      viewLogDetails (data) {
        this.logDetails = true;
        this.logData = data;
      },
      addNewAvatar () {
        this.avatarList.push({
          avatar: ''
        })
      },
      getIcon (type) {
        let icon = 'mdi-office-building-outline';
        if (type === 'user_logged_in') {
          icon = 'mdi-account-arrow-left-outline'
        }
        if (type === 'user_login_failed') {
          icon = 'mdi-account-remove-outline'
        }
        if (type === 'reminder') {
          icon = 'mdi-bell-ring-outline'
        }
        if (type === 'company_added') {
          icon = 'mdi-office-building-outline'
        }
        if (type === 'driver_deleted' || type === 'driver_updated' || type === 'driver_added') {
          icon = 'mdi-lifebuoy'
        }
        if (type === 'company_settings') {
          icon = 'mdi-office-building-outline'
        }
        if (type === 'company_profile') {
          icon = 'mdi-office-building-outline'
        }
        if (type === 'plan_settings') {
          icon = 'mdi-office-building-outline'
        }
        if (type === 'user_logged_out') {
          icon = 'mdi-account-arrow-right-outline'
        }
        if (type === 'chat_feedback') {
          icon = 'mdi-download-outline'
        }
        if (type === 'report_download') {
          icon = 'mdi-file-download-outline'
        }
        if (type === 'touchpoint_upload') {
          icon = 'mdi-map-marker-path'
        }
        if (type === 'admin_added') {
          icon = 'mdi-account-plus-outline'
        }
        return icon;
      },
      getColor (type) {
        let color = 'indigo lighten-4';
        if (type === 'user_logged_in') {
          color = 'green lighten-4'
        }
        if (type === 'user_login_failed') {
          color = 'red lighten-4'
        }
        if (type === 'user_logged_out') {
          color = 'green lighten-4'
        }
        if (type === 'reminder') {
          color = 'indigo lighten-4'
        }
        if (type === 'driver_deleted' || type === 'driver_updated' || type === 'driver_added') {
          color = 'indigo lighten-4'
        }
        if (type === 'company_added') {
          color = 'indigo lighten-4'
        }
        if (type === 'plan_settings') {
          color = 'indigo lighten-4'
        }
        if (type === 'company_settings') {
          color = 'indigo lighten-4'
        }
        if (type === 'company_profile') {
          color = 'indigo lighten-4'
        }
        if (type === 'chat_feedback') {
          color = 'indigo lighten-4'
        }
        if (type === 'touchpoint_upload') {
          color = 'indigo lighten-4'
        }
        if (type === 'report_download') {
          color = 'indigo lighten-4'
        }
        if (type === 'admin_added') {
          color = 'indigo lighten-4'
        }
        return color;
      },
      closeDialog () {
        this.subdriverDialog = false;
        this.selectedDriver = '';
        this.selectedSubDriver = '';
        this.subdriverName = '';
        this.subDriverDescription = '';
      },
      addNewSubDriver (driver) {
        this.selectedDriver = driver;
        this.subdriverDialog = true;
      },
      editSubDriver (driver, subdriver) {
        this.selectedDriver = driver;
        this.selectedSubDriver = subdriver;
        this.subdriverName = subdriver.sub_driver;
        this.subdriverDialog = true;
      },
      saveSubdriver () {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.post(`${process.env.VUE_APP_API_URL}company/drivers?company_id=${this.$route.query.cid}`, {
          driver: this.selectedDriver,
          sub_driver: this.subdriverName,
          sub_driver_description: this.subDriverDescription ? this.subDriverDescription : undefined,
        }, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.closeDialog();
            this.getDrivers();
            this.subdriverName = '';
            this.subDriverDescription = '';
            this.selectedDriver = '';
            this.selectedSubDriver = '';
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Subdriver has been added successfully!'
            });
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to add subdriver, Please try again later!'
            });
          }
        });
      },
      updateSubdriver () {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.post(`${process.env.VUE_APP_API_URL}company/drivers?company_id=${this.$route.query.cid}&id=${this.selectedSubDriver.id}`, {
          driver: this.selectedDriver,
          sub_driver: this.subdriverName,
          sub_driver_description: this.subDriverDescription ? this.subDriverDescription : undefined,
        }, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.closeDialog();
            this.getDrivers();
            this.subdriverName = '';
            this.subDriverDescription = '';
            this.selectedDriver = '';
            this.selectedSubDriver = '';
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Subdriver has been added successfully!'
            });
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to add subdriver, Please try again later!'
            });
          }
        });
      },
      deleteSubDriver (subdri) {
        this.$swal({
          title: 'Are you sure?',
          text: "You want to delete this sub driver!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete!'
        }).then((result) => {
          if (result.isConfirmed) {
            // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
            axios.delete(`${process.env.VUE_APP_API_URL}company/drivers?company_id=${this.$route.query.cid}&id=${subdri.id}`, {
              withCredentials: true
            }).then((response) => {
              if (response && response.data) {
                this.getDrivers();
                this.$store.dispatch('updateSnackbar', {
                  color: 'success',
                  show: true,
                  text: 'Sub driver deleted successfully!'
                });
              }
            }).catch((err) => {
              if (err.response.status === 429) {
                this.config.savingStage = false;
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.error
                });
              } else {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: 'Unable to trigger reminders, Please try again later!'
                });
              }
            });
          }
        });
      },
      changeTab (url) {
        if (url === 'company-list' && this.$route.query.page) {
          this.$router.push(`/${url}?page=${this.$route.query.page}`);
        } else {
          this.$router.push(`/${url}`);
        }
    },
    formatDate1 (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    sendReminder () {
      this.$swal({
          title: 'Are you sure?',
          text: "You want to trigger reminders!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, send!'
        }).then((result) => {
          if (result.isConfirmed) {
            // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
            axios.get(`${process.env.VUE_APP_API_URL}reminder/trigger_reminders/${this.$route.query.cid}`, {
              params: {
                status: 'draft'
              },
              withCredentials: true
            }).then((response) => {
              if (response && response.data) {
                  this.$store.dispatch('updateSnackbar', {
                    color: 'success',
                    show: true,
                    text: 'Chat reminders queued successfully!'
                  });
              }
            }).catch((err) => {
              if (err.response.status === 429) {
                this.config.savingStage = false;
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.error
                });
              } else {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: 'Unable to trigger reminders, Please try again later!'
                });
              }
            });
          }
        });
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('-');
      return `${year}-${month}-${day}`;
    },
      editDetails (companyData) {
        this.editCompanyView = true;
        setTimeout(() => {
        delete companyData.company_details.tags;
        delete companyData.company_details.users_status;
        delete companyData.company_settings.employee_tags;
        if (this.companyData.company_settings && this.companyData.company_settings.inbound_topics) {
          let cleanedTopics = this.companyData.company_settings.inbound_topics.map(t =>
            t.replace(/_/g, " ")
          );
          this.companyData.company_settings.inbound_topics = cleanedTopics;
        }
        this.$store.state.activeCompany.company_details = JSON.stringify(companyData.company_details);
        this.$store.state.activeCompany.company_settings = JSON.stringify(companyData.company_settings);
        this.$store.state.activeCompany.plan_details = JSON.stringify(companyData.plan_details);
        this.$store.state.activeCompany.company_billing_entries = JSON.stringify(companyData.company_billing_entries[0]);
        this.$store.dispatch('updateCompany', this.$store.state.activeCompany);
        // this.$refs.addcompany.dialog = true;
        this.$refs.addcompany.company_settings = companyData.company_settings;
        this.$refs.addcompany.companyAvatar[0].company_avatar = companyData.company_details.company_avatar;
        this.$refs.addcompany.editView = true;
        this.$refs.addcompany.company = companyData.company_details;
        if (companyData && companyData.company_details && companyData.company_details.activatedAt) {
          const [year, month, day] = companyData.company_details.activatedAt.split('-');
          this.$refs.addcompany.company.activatedAt = `${day}-${month}-${year}`;
        }
        this.$refs.addcompany.plan = companyData.plan_details;
        if (companyData.company_billing_entries[0]) {
          this.$refs.addcompany.billing = companyData.company_billing_entries[0];
        } else {
          this.$refs.addcompany.billing = {};
        }
        
        this.planOld = companyData.plan_details;
        this.$refs.addcompany.company_settings = companyData.company_settings;
        this.settingsOld = companyData.company_settings;
        this.$refs.addcompany.loadingData = false;
        }, 500);
      },
      downloadRatingReports () {
      this.$store.dispatch('updateSnackbar', {
        color: 'warn',
        show: true,
        text: 'Generating report, Please wait!'
      });
      axios.get(`${process.env.VUE_APP_API_URL}company/policy/download/${this.$route.query.cid}`, {
        withCredentials: true
      }).then((response) => {
        if (response && response.data && response.data.success) {
          if (response.data && response.data.report_url) {
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.report_url);
            }, 100);
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.reportDialog = false;
        }
        this.downloadingFlag = false;
      }).catch((err) => {
        if (err.response.status === 429) {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
      },
      downloadLoginReports () {
      this.$store.dispatch('updateSnackbar', {
        color: 'warn',
        show: true,
        text: 'Generating report, Please wait!'
      });
      axios.get(`${process.env.VUE_APP_API_URL}company/login-logs/download/${this.$route.query.cid}`, {
        withCredentials: true
      }).then((response) => {
        if (response && response.data && response.data.success) {
          if (response.data && response.data.report_url) {
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.report_url);
            }, 100);
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.reportDialog = false;
        }
        this.downloadingFlag = false;
      }).catch((err) => {
        if (err.response.status === 429) {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
      },
      downloadTouchpointReports () {
      this.$store.dispatch('updateSnackbar', {
        color: 'warn',
        show: true,
        text: 'Generating report, Please wait!'
      });
      axios.get(`${process.env.VUE_APP_API_URL}stage/export/${this.$route.query.cid}?touchpoint_langs=${this.languageConfigured}`, {
        withCredentials: true
      }).then((response) => {
        if (response && response.data && response.data.file_url) {
          if (response.data && response.data.file_url) {
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.file_url);
            }, 100);
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Touchpoint report downloaded successfully!'
            });
            this.langDialog = false;
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.reportDialog = false;
        }
        this.downloadingFlag = false;
      }).catch((err) => {
        if (err.response.status === 429) {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
      },
      downloadRating (i) {
      this.reportloading = true;
      this.$store.dispatch('updateSnackbar', {
        color: 'warn',
        show: true,
        text: 'Generating report, Please wait!'
      });
      if (this.chatCompleteDateModel === 'this_week') {
        this.chatCompletion.startDate = dayjs().subtract(6, 'day').format();
        this.chatCompletion.endDate = dayjs().format();
      }
      if (this.chatCompleteDateModel === 'last_month') {
        this.chatCompletion.startDate = dayjs().subtract(1, 'month').add(1, 'day').format();
        this.chatCompletion.endDate = dayjs().format();
      }
      if (this.chatCompleteDateModel === 'last_3_months') {
        this.chatCompletion.startDate = dayjs().subtract(3, 'month').add(1, 'day').format();
        this.chatCompletion.endDate = dayjs().format();
      }
      if (this.chatCompleteDateModel === 'last_6_months') {
        this.chatCompletion.startDate = dayjs().subtract(6, 'month').add(1, 'day').format();
        this.chatCompletion.endDate = dayjs().format();
      }
      if (this.chatCompleteDateModel === 'last_12_months') {
        this.chatCompletion.startDate = dayjs().subtract(12, 'month').add(1, 'day').format();
        this.chatCompletion.endDate = dayjs().format();
      }
      const queryParams = {
        latest_completed_chat: i === 'latest' ? true : undefined,
        dashboard_type: this.reportTypeFeedback,
        completed_date_start: this.chatCompletion.startDate ? dayjs(this.chatCompletion.startDate).format('YYYY-MM-DD') : undefined,
        completed_date_end: this.chatCompletion.endDate ? dayjs(this.chatCompletion.endDate).format('YYYY-MM-DD') : undefined
      };
      axios.get(`${process.env.VUE_APP_API_URL}report/feedback_report/${this.$route.query.cid}`, {
        params: queryParams,
        withCredentials: true
      }).then((response) => {
        this.dialogOpen = false;
        this.reportType = '';
        if (response && response.data && response.data.success) {
          if (response.data && response.data.report_url) {
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.report_url);
            }, 100);
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Happiness index report downloaded successfully!'
            });
            this.dialogOpen = false;
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.reportDialog = false;
        }
        this.reportloading = false;
        this.downloadingFlag = false;
      }).catch((err) => {
        this.dialogOpen = false;
        this.reportloading = false;
        this.reportType = '';
        if (err.response.status === 429) {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
      },
      resendEmail (id){
        this.$swal({
          title: 'Are you sure?',
          text: "You want to resend credentials email again!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#10b981 ',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, resend!'
        }).then((result) => {
          if (result.isConfirmed) {
            // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
            axios.get(`${process.env.VUE_APP_API_URL}users/generate/password/${id}`, {
              withCredentials: true
            }).then((response) => {
              this.loading = false;
              this.open = false;
              this.$store.dispatch('updateSnackbar', {
                color: 'success',
                show: true,
                text: 'Email sent successfully!'
              });
              this.$parent.getAdmins(this.$route.query.cid);
              this.getAdmins(this.$route.query.cid)
            }, (response) => {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: 'Unable to upload admin, Please try again later!'
              });
              throw new Error(response);
            });
          }
        });
      
    },
      getAdmins (id) {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}users/admins/${id}`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.companyAdmins = response.data.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
      getSatgeDetails (id, id1, item) {
        this.$refs.stagedetails.getAdmins(this.$route.query.cid);
        this.selectedStage = id1;
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        
        axios.get(`${process.env.VUE_APP_API_URL}survey/${id}/details?fields=title,type,description,company,createdAt,createdBy,lastUpdated,interactions,interactions_ms,interactions_tl,interactions_th,stage_status`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
             this.$refs.stagedetails.question = response.data.interactions;
            if (item.chatFromUser) {
              this.$refs.stagedetails.chat_on_behalf = item.chatFromUser;
            } else {
              this.$refs.stagedetails.chat_on_behalf = '';
            }
            this.$refs.stagedetails.stageDialog = true;
            this.$refs.stagedetails.stageData = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
      getDrivers () {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/drivers?company_id=${this.$route.query.cid}`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.driverList = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
      saveDetails () {
        this.editView = false;
      },
      openAdminModal (data) {
        this.$refs.addadmin.open = true;
        this.$refs.addadmin.candidate = {};
        if (data) {
          this.$refs.addadmin.editView = true;
          this.$refs.addadmin.candidate = data;
        }
      },
      openTouchpointModal () {
        this.$refs.addtouchpoint.dialogTouchpoint = true;
      },
      openSortingModal () {
        this.touchpointList = {};
        this.sortBy = '';
        this.loaderforAction = true;
        this.dialogSorting = true;
        this.getTouchpointList ();
      },
      getTouchpointList () {
        this.loaderforAction = true;
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}/stage/list/${this.$route.query.cid}?count=true&stageType__in=lifecycle&fields=id,title`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data && response.data) {
            this.touchpointList = response.data;
            this.loaderforAction = false;
          }
        }).catch((err) => {
          this.loaderforAction = false;
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
      getAvatar () {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/avatar`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.avatarList = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
      openModal () {
        this.$refs.addcompany.dialog = true;
        this.$refs.addcompany.company = {};
        this.$refs.addcompany.editView = false;
        this.$refs.addcompany.company.companies_avatar = this.avatarList;
        this.$refs.addcompany.company.is_active = true;
        this.$refs.addcompany.company.chat_cobranding_enabled = false;
        this.$refs.addcompany.company.allow_stage_edit = false;
        this.$refs.addcompany.companyAvatar[0].company_avatar = this.companyData.company_details.company_avatar;
      },
      getstagesBulk (id) {
        this.loaderforActionBulk = true
        this.bulkActionTouchpoint = [];
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        const queryParams = {
        count: 'true',
        stageType__in: 'lifecycle',
      };
        axios.get(`${process.env.VUE_APP_API_URL}stage/list/${id}`, {
          params: queryParams,
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.companyTouchpointsBulk = response.data.data;
            this.loaderforActionBulk = false;
          }
        }).catch((err) => {
          this.loaderforActionBulk = false;
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
      getSatges (id) {
        this.bulkActionTouchpoint = [];
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        const queryParams = {
        count: 'true',
        page_limit: this.pagination.rowsPerPage,
        page_offset: this.pagination.page || 1,
        stageType__in: 'lifecycle',
      };
        axios.get(`${process.env.VUE_APP_API_URL}stage/list/${id}`, {
          params: queryParams,
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.pagination.length = Math.ceil(response.data.count / this.pagination.rowsPerPage);
            this.companyTouchpoints = response.data.data;
            this.deactivateStageL = false;
            this.liveStageL = false;
            this.deleteStageL = false;
          }
        }).catch((err) => {
          this.deactivateStageL = false;
          this.liveStageL = false;
          this.deleteStageL = false;
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
      getCompanyDetails (id) {
        this.isLoadingData = true;
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/profile/${this.$route.query.cid}?fields=company_name,brand_name,spoc_name,allow_stage_edit,spoc_email,spoc_phone,country,company_address,company_logo,createdBy,company_type,chat_cobranding_enabled,createdAt,is_active,employee_strength,chat_cobranding_enabled,tags,facebook_link,linkedin_link,glassdoor_link,jobStreet_link,activatedAt,user_booked,users_status,companies_avatar,company_avatar,total_arr,renewal_date,is_visible_in_admin_panel,employee_data_source`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            if (response.data.plan_details && response.data.plan_details.title) {
              if (response.data.plan_details.title.split(' - ')[1]) {
                response.data.plan_details.title = response.data.plan_details.title.split(' - ')[1]
              }
            }
            if (response.data.company_billing_entries[0] && response.data.company_billing_entries[0].total_arr) {
              response.data.company_billing_entries[0].total_arr = response.data.company_billing_entries[0].total_arr.split('.')[0]
            }
            if (response.data.company_billing_entries[0] && response.data.company_billing_entries[0].total_arr) {
              response.data.company_billing_entries[0].total_arr = response.data.company_billing_entries[0].total_arr.split('.')[0]
            }
            if (response.data.company_billing_entries[0] && response.data.company_billing_entries[0].rate_per_user) {
              response.data.company_billing_entries[0].rate_per_user = response.data.company_billing_entries[0].rate_per_user.split('.')[0]
            }
            if (response.data.company_billing_entries[0] && response.data.company_billing_entries[0].total_subscription_cost) {
              response.data.company_billing_entries[0].total_subscription_cost = response.data.company_billing_entries[0].total_subscription_cost.split('.')[0]
            }
            if (response.data.company_billing_entries && response.data.company_billing_entries[0] && response.data.company_billing_entries[0].one_time_setup_cost) {
              response.data.company_billing_entries[0].one_time_setup_cost = response.data.company_billing_entries[0].one_time_setup_cost.split('.')[0]
            }
            if (response.data.company_billing_entries && response.data.company_billing_entries[0] && response.data.company_billing_entries[0].hris_integration_cost) {
              response.data.company_billing_entries[0].hris_integration_cost = response.data.company_billing_entries[0].hris_integration_cost.split('.')[0]
            }
            if (response.data.company_billing_entries && response.data.company_billing_entries[0] && response.data.company_billing_entries[0].subsequent_invoice_amount) {
              response.data.company_billing_entries[0].subsequent_invoice_amount = response.data.company_billing_entries[0].subsequent_invoice_amount.split('.')[0]
            }
            if (response.data.company_billing_entries && response.data.company_billing_entries[0] && response.data.company_billing_entries[0].company_invoicing) {
              response.data.company_billing_entries[0].company_invoicing = response.data.company_billing_entries[0].company_invoicing.split('.')[0]
            }
            if (response.data.company_billing_entries && response.data.company_billing_entries[0] && response.data.company_billing_entries[0].company_total_billing_with_tax) {
              response.data.company_billing_entries[0].company_total_billing_with_tax = response.data.company_billing_entries[0].company_total_billing_with_tax.split('.')[0]
            }
            if (response.data.company_billing_entries && response.data.company_billing_entries[0] && response.data.company_billing_entries[0].total_payment_received) {
              response.data.company_billing_entries[0].total_payment_received = response.data.company_billing_entries[0].total_payment_received.split('.')[0]
            }
            if (response.data.company_billing_entries && response.data.company_settings && response.data.company_settings.genai_features) {
              response.data.company_settings.genai_features = JSON.stringify(response.data.company_settings.genai_features);
            }
            if (response.data.company_details.activatedAt ) {
              const [year, month, day] = response.data.company_details.activatedAt.split('-');
              response.data.company_details.activatedAt = `${day}-${month}-${year}`;
            }
            if (response.data.company_billing_entries.length && response.data.company_billing_entries[0].billing_start_date ) {
              const [year, month, day] = response.data.company_billing_entries[0].billing_start_date.split('-');
              response.data.company_billing_entries[0].billing_start_date = `${day}-${month}-${year}`;
            }
            if (response.data.company_billing_entries.length && response.data.company_billing_entries[0].contract_start_date ) {
              const [year, month, day] = response.data.company_billing_entries[0].contract_start_date.split('-');
              response.data.company_billing_entries[0].contract_start_date = `${day}-${month}-${year}`;
            }
            if (response.data.company_billing_entries.length && response.data.company_billing_entries[0].contract_renewal_date ) {
              const [year, month, day] = response.data.company_billing_entries[0].contract_renewal_date.split('-');
              response.data.company_billing_entries[0].contract_renewal_date = `${day}-${month}-${year}`;
            }
            if (response.data.company_billing_entries.length && response.data.company_billing_entries[0].contract_valid_upto ) {
              const [year, month, day] = response.data.company_billing_entries[0].contract_valid_upto.split('-');
              response.data.company_billing_entries[0].contract_valid_upto = `${day}-${month}-${year}`;
            }
            if (response.data.company_details.renewal_date ) {
              const [year, month, day] = response.data.company_details.renewal_date.split('-');
              response.data.company_details.renewal_date = `${day}-${month}-${year}`;
            }
            if (response.data.company_details && response.data.company_details.activatedAt) {
              response.data.company_details.activatedAt = response.data.company_details.activatedAt.split(' ')[0];
            }
            if (response.data.company_details && response.data.company_details.renewal_date) {
              response.data.company_details.renewal_date = response.data.company_details.renewal_date.split(' ')[0];
            }
            this.companyData = response.data;
            this.isLoadingData = false;
            if (this.$route.query.editview) {
            }
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
    },
    mounted () {
      this.getCompanyDetails(this.$route.query.cid);
      this.getAdmins(this.$route.query.cid);
      this.getAvatar();
      this.getstagesBulk(this.$route.query.cid);
      if (this.$route.query && this.$route.query.touchpoint) {
        this.tabs = 'c_touchpoints';
        this.getSatges(this.$route.query.cid);
        this.getstagesBulk(this.$route.query.cid);
      }
    }
  }
</script>
<style lang="scss" >
.daterangeOverview {
  input {
    display: none;
  }
}
.ql-editor p,
.ql-editor div {
  margin: 0 !important;
  padding: 0 !important;
}
.heading {
  font-size: 16px;
  padding-top:10px;
}
.dashboardCount {
  font-size: 70px;
  padding:10%;
}
.mainBox:hover {
  transform: scale(1.05);
}
.mainBox {
      background-color: white;
    border-radius: 6px;
    box-shadow: 0 4px 16px 11px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 10%) !important;
    height: 16rem;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    text-align: center;
}
.onlyThis .v-toolbar__content {
  display: none !important;
}
.app--text {
  color:black !important;
}
.primary--text {
  color: #10b981  !important;
}
.adminHeading {
}

.disabledView {
    cursor: not-allowed;
    pointer-events: none;
}
.avatarBox {
  border: 1px solid #eaeaea;
  border-radius:6px;
}
.editAvatarBox {
  pointer-events: initial;
}
.editAvatarBox:hover {
  border: 2px solid #10b981 ;
  cursor: pointer;
}
.am-card-animation {
  border-radius: 6px;
  transition: all .4s;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
}
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.am-table-title {
  font-size: 14px !important;
  line-height: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 500 !important;
  font-family: "Poppins", sans-serif !important;
}
.am-table-sub-title {
  font-size: 12px;
  line-height: 18px;
  color: #878a99;
  font-weight: 500 !important;
  font-family: "Poppins", sans-serif !important;
}
.hover-elevation {
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}
.hover-elevation:hover {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}
.sticky-header {
  position: sticky;
  top: 63px; 
  z-index: 10; 
  background-color: #f6f6f8;
}
.quill-editor-1 .ql-container {
  min-height: 150px;
  border-radius: 0 0 8px 8px ;

}
.quill-editor-2 .ql-container {
  min-height: 80px;
  border-radius:  8px ;
}
.quill-editor-3 .ql-container {
  min-height: 80px;
  border-radius:  8px ;
}
.ql-editor p {
  padding: 5px !important;
}
.button{
  background-color: #10b981  !important;
  color:white !important;
}
.hover:hover {
  background-color: #10b981 ;
    color: white;
    position: relative;
    text-align: center;
    padding: 10px;
}
.hover:hover::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background-color: #10b981 ;
}
.hover1:hover::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background-color: #10b981 ;
}
.hover1:hover {
  position: relative;
  background-color: #10b981 ;
    color: white;
}
.reportOption {
    border: 2px solid lightgray;
    padding: 10px;
    text-align: center;
    cursor: pointer;
    border-radius: 6px;
    // &:hover {
    //   border: 2px solid #10b981 ;
    // }
    &.active {
      border: 2px solid #10b981 ;
    }
}
.am-table-title label {
  font-size: 14px !important;
  line-height: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 500 !important;
  font-family: "Poppins", sans-serif !important;
}
.v-tabs-slider {
  display: none;
}
.v-tab--active {
  background: #6366f1 !important;
    color: #fff !important;
    border-radius: 24px;
}
.v-tab {
    padding: 8px 12px;
    text-decoration: none;
    letter-spacing: 1px;
    position: relative;
    background: #6366f121;
    border-radius: 24px;
    min-width: 70px;
    text-align: center;
    font-size: 12px;
}
.v-tab:hover {
  background: #6366f1 !important;
  color: #fff !important;
  border-radius: 24px;
}
.v-slide-group__content {
  gap: 12px;
  height: 36px;
}
</style>
